import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {DialogSaveButton,TableRadioButton,TreeNodeCheckBox,AssigmentDetailsIconLayout} from '../../../common/Global/globalStyles.style';
import RegularDropdown from '../../../common/DropdownMenus/RegularDropdown';
import {getLocalStorageVariables,isEmptyVariable,isEmptyArray,hasFeatureAccess,isFormDirty, handleTokenExpiry} from '../../../common/Global/commonFunctions';
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-react-dropdowns/styles/material.css";
import ReactSelectDropdown from '../../../common/DropdownMenus/ReactSelectDropdownWithSearch';
import moment from "moment";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import {Modal} from 'react-bootstrap';
import SelectFunctionDialog from '../Common/selectFunction';
import SelectProcessDialog from '../Common/selectProcess';
import SelectPlannedAssignment from '../Common/selectPlannedAssignment';
import CreatableSelect from "react-select/creatable";
import PreviousRefNoDialog from './previousRefNoDialog';
import AlertDialog from '../../../common/AlertDialog';

const epicCustomStyles = {
	placeholder: (provided, state) => ({
		...provided,
		fontSize: 13,
        color:"#ccc"
	}),
	option: (provided, state) => ({
		...provided,
		fontSize: 13,
        background:state.isFocused?"#f8f9fa":"transparent",
        ":hover":{
            background:"#f8f9fa"
        }
	}),
	singleValue: (provided, state) => ({
		...provided,
		fontSize: 13,
	}),
	input: (provided, state) => ({
		...provided,
		fontSize: 14,
	}),
	control: (provided, state) => ({
		...provided,
		// border: "1px solid transparent",
		minHeight: 34,
		// ":hover": {
		// 	border: "1px solid red",
		// },
	}),
    menuList: (provided, state) => ({
		...provided,
		maxHeight:300,
        paddingTop:0,
        paddingBottom:0,
	}),
    menu:(provided, state)=>({
        ...provided,
        marginTop:2
    })
};
const functionDropdownDefaultValue = "Select Function";
const processDropdownDefaultValue = "Select Process";
const companyDefaultPlaceholder = "Select Client";
const plannedAssignmentDefaultPlaceholder = "Select Assignment";
const unitDefaultPlaceholder = "Select Units";
const projectDefaultPlaceholder = "Select Project";
const employeeDefaultPlaceholder = "Select Employee";
const departmentDropdownDefaultValue = "Select Department";
const assignmentTypeDefaultPlaceholder = "Select Assignment Type";
const observationTemplateDefaultPlaceholder = "Select Observation Template";
const execTaskTemplateDefaultPlaceholder = "Select Execution Task Template";
const defaultRiskPlaceholder = "Select Risk";
const defaultVAPlaceholder = "Select Value Addition";
const unplannedReasonDefaultPlaceholder = "Select Reason";
const defaultLikelihoodPlaceholder = "Select Likelihood";
const auditTypeDefaultPlaceholder = "Select Audit Type";
const selectedAssignmentEntityEmployee = "Employee";
const selectedAssignmentEntityProject = "Project";
const selectedAssignmentEntityUnit = "Unit";
let userDetails = getLocalStorageVariables();


class CreateAnnualPlan extends Component{
    constructor(props){
        super(props);
        this.state = {
            isUnplannedNewAssignment:false,
            planDate:"",
            selectedCompanyId:"",
            selectedCompanyPlaceholder:companyDefaultPlaceholder,
            
            companyUnits:[],
            selectedUnitObj:[],
            projects:[],
            employees:[],
            selectedProjectObj:[],
            selectedEmployeeObj:[],
            selectedUnitPlaceholder:unitDefaultPlaceholder,
            selectedProjectPlaceholder:projectDefaultPlaceholder,
            selectedEmployeePlaceholder:employeeDefaultPlaceholder,
            isUnitsDropdownEnabled:false,
            
            selectedAssignmentTypeId:"",
            assignmentTypeFiltered:[],
            selectedAssignmentTypePlaceholder:assignmentTypeDefaultPlaceholder,
            selectedAuditType:auditTypeDefaultPlaceholder,
            selectAssignmentEntityFlag:false,
            auditTypesFiltered:[],
            assignmentTypeFlag:false,
            assignmentArea:"",
            selectedFunctionObjArr:[],
            selectedProcessObjArr:[],

            selectedPlannedAssignment:plannedAssignmentDefaultPlaceholder,
            selectedPlannedAssignmentId:"",
            datalist:[],
            disablePlannedAssignment:true,

            selectedDepartmentId:"",
            selectedDepartmentName:departmentDropdownDefaultValue,
            
            startDate:"",
            endDate:"",
            reportDate:"",
            referenceNo:"",

            selectedRiskPlaceholder:defaultRiskPlaceholder,
            selectedRiskId:"",
            isRiskEdit:false,

            selectedValuePlaceholder:defaultVAPlaceholder,
            selectedVAIds:[],

            periodFromDate:"",
            periodToDate:"",
            unplannedReasonPlaceholder:unplannedReasonDefaultPlaceholder,
            unplannedRemarks:"",

            observationTemplatesFiltered:[],
            selectedObservationTemplateId:"",
            selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,

            execTaskTemplatesFiltered:[],
            selectedExecTaskTemplateId:"",
            selectedExecTaskTemplatePlaceholder:execTaskTemplateDefaultPlaceholder,

            tagsSelectedDD1:[],
            tagsSelectedDD2:[],
            tagsSelectedDD3:[],

            submitClickedAtleastOnce:false,
            formErrors:{},
            showLoader:false,

            selectedScheduleAssignment:false,
            selectedCompanyObj:[],
            selectedObservationTempObj:[],

            showPreviousRefDialog:false,
            hidePlannedAssignment:false,
            departmentSetting:[],
            
            selectedLikelihood: defaultLikelihoodPlaceholder,
            selectedLikelihoodId: "",
            isLikelihoodEdit:false,

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            isLikelihood:false,
            isRisk:false,
            selectedRiskObj:[],
            selectedLikelihoodObj:[],
            isSampleChecked:false,
            risks:[],
            likelihoods:[],
            isFormDirty: false,
            showConfirmClose: false,
            pendingCloseAction: null,
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showCreateDialog){
            let selectedDepartmentId = this.props.selectedDepartmentId;
            let selectedDepartmentName = this.props.selectedDepartmentName;

            if(this.props.isEdit){
                let dropdownItem = this.props.selectedItem;
                let companyUnits = [];
                companyUnits = this.props.units.filter(unit => unit.companyId === dropdownItem.companyId);
                let assignmentTypeFiltered = this.props.assignmentType.filter(at => at.departmentId === dropdownItem.departmentId);
                let execTaskTemplatesFiltered = this.props.execTaskTemplates.filter(at => at.assignmentTypeId === dropdownItem.assignmentTypeId);
                let observationTemplatesFiltered = this.props.observationTemplates.filter(at => at.departmentId === dropdownItem.departmentId && at.assignmentTypeId === dropdownItem.assignmentTypeId);
                
                let obsObj = observationTemplatesFiltered.find(item=>item.templateId == dropdownItem.observationTemplateId);
                let flagO = obsObj?.fixedTemplateFields?.includes('"valueAddition":"Y"');
                let execObj = execTaskTemplatesFiltered.find(item=>item.templateId == dropdownItem.executionTemplateId);
                let flagE = execObj?.fixedTemplateFields?.includes('"valueAddition":"Y"');

                let tagsSelectedDD1 = [];
                if(!isEmptyVariable(dropdownItem.groupSet1)){
                    let splitArr = dropdownItem.groupSet1.split(":-:");
                    tagsSelectedDD1 = splitArr.map(item=>{
                        let idNameArr = item.split("$-$");
                        let obj = {value:parseInt(idNameArr[0]),label:idNameArr[1]}
                        return obj;
                    });
                }
                let tagsSelectedDD2 = [];
                if(!isEmptyVariable(dropdownItem.groupSet2)){
                    let splitArr = dropdownItem.groupSet2.split(":-:");
                    tagsSelectedDD2 = splitArr.map(item=>{
                        let idNameArr = item.split("$-$");
                        let obj = {value:parseInt(idNameArr[0]),label:idNameArr[1]}
                        return obj;
                    });
                }
                let tagsSelectedDD3 = [];
                if(!isEmptyVariable(dropdownItem.groupSet3)){
                    let splitArr = dropdownItem.groupSet3.split(":-:");
                    tagsSelectedDD3 = splitArr.map(item=>{
                        let idNameArr = item.split("$-$");
                        let obj = {value:parseInt(idNameArr[0]),label:idNameArr[1]}
                        return obj;
                    });
                }

                let selectedAssignmentGroups = {
                    groupSet1:tagsSelectedDD1,
                    groupSet2:tagsSelectedDD2,
                    groupSet3:tagsSelectedDD3,
                }

                //First Lets Check whether it is planned or unplanned
                let isUnplannedAssignment = false;
                let unplannedReason = unplannedReasonDefaultPlaceholder;
                let unplannedRemarks = "";
                if(!isEmptyVariable(dropdownItem.unplannedReason)){
                    // isUnplannedAssignment = true;
                    unplannedReason = dropdownItem.unplannedReason;
                    unplannedRemarks = dropdownItem.unplannedRemark;
                }

                let newCompanyUnits = [];
                if(dropdownItem.auditType === selectedAssignmentEntityProject){
                    newCompanyUnits = [{
                        unitNameAndCity:"All",
                        unitId:""
                    }]
                }
                Object.values(companyUnits).map((item)=>{
                    let  tempItem = item
                    tempItem["unitNameAndCity"] = item.unitName+", "+item.city
                    newCompanyUnits.push(tempItem)
                })

                let selectedUnitObj = [];
                if(dropdownItem.auditType === selectedAssignmentEntityProject){
                    let projectUnitId = dropdownItem.projectUnitId?JSON.parse(dropdownItem.projectUnitId):[];
                    projectUnitId.map(item => {
                        newCompanyUnits.map((unit)=>{
                            if(unit.unitId==parseInt(item))
                            {
                                selectedUnitObj.push(unit)
                            }
                        })
                    })
                    
                    if(selectedUnitObj.length === companyUnits.length){
                        selectedUnitObj = [{
                            unitNameAndCity:"All",
                            unitId:""
                        }];
                    }
                }else if(dropdownItem.auditType === selectedAssignmentEntityEmployee){
                    let employeeUnitId = dropdownItem.employeeUnitId?JSON.parse(dropdownItem.employeeUnitId):[];
                    employeeUnitId.map(item => {
                        newCompanyUnits.map((unit)=>{
                            if(unit.unitId==parseInt(item)){
                                selectedUnitObj.push(unit)
                            }
                        })
                    })
                }else{
                    if(!isEmptyVariable(dropdownItem.unitList)){
                        let splitArr = dropdownItem.unitList.split(";;");
                        if(!isEmptyArray(splitArr)){
                            splitArr.map((item)=>{
                                newCompanyUnits.map((unit)=>{
                                    if(unit.unitId==parseInt(item.split(":-:")[1]))
                                    {
                                        selectedUnitObj.push(unit)
                                    }
                                })
        
                            })
                        }
                    }
                }
                let projects = this.props.projects.filter(item => item.companyId === dropdownItem.companyId);
                let selectedProjectObj = [];
                if(!isEmptyVariable(dropdownItem.projectList)){
                    projects.map((project)=>{
                        if(project.projectId==parseInt(dropdownItem.projectList.split(":-:")[2]))
                        {
                            selectedProjectObj.push(project)
                        }
                    })
                }

                let employees = this.props.employees.filter(item => {
                    return JSON.parse(item.unit).some(unit => 
                        unit == dropdownItem.employeeUnitId.replace(/[\[\]]/g, "")
                    );
                });
                let newEmployees = []
                Object.values(employees).map((item)=>{
                    let tempItem = item
                    tempItem["empAndDesignation"] = item.salutation+" "+item.firstName+" "+item.lastName+" ("+item.designation+")"
                    newEmployees.push(item)
                })

                let selectedEmployeeObj = [];
                let splitArr = dropdownItem.employeeList.split(";;");
                if(!isEmptyArray(splitArr)){
                    splitArr.map(item => {
                        newEmployees.map(emp => {
                            if(emp.employeeId == parseInt(item.split(":-:")[1])){
                                selectedEmployeeObj.push(emp)
                            }
                        })
                    })
                }

                let selectedProcessObjArr = [];
                if(!isEmptyVariable(dropdownItem.processList)){
                    let splitArr = dropdownItem.processList.split("|~|");
                    if(!isEmptyArray(splitArr)){
                        splitArr.forEach((item)=>{
                            if(!isEmptyVariable(item.split(":-:")[1])){
                                selectedProcessObjArr.push({
                                    processId:item.split(":-:")[1]
                                })
                            }
                        })
                    }
                }
                this.state.selectedCompanyObj['companyName']=!isEmptyVariable(dropdownItem.companyName)?dropdownItem.companyName:""
                this.state.selectedCompanyObj['companyId']=!isEmptyVariable(dropdownItem.companyId)?dropdownItem.companyId:""
                let selectedRiskObj = isEmptyVariable(dropdownItem.riskId) ? [] : {};
                selectedRiskObj['name']=!isEmptyVariable(dropdownItem.riskName)?dropdownItem.riskName:defaultRiskPlaceholder
                selectedRiskObj['riskId']=!isEmptyVariable(dropdownItem.riskId)?dropdownItem.riskId:""
                
                let selectedLikelihoodObj = isEmptyVariable(dropdownItem.likelihoodId) ? [] : {};
                selectedLikelihoodObj['name']=!isEmptyVariable(dropdownItem.likelihoodName)?dropdownItem.likelihoodName:defaultLikelihoodPlaceholder
                selectedLikelihoodObj['likelihoodId']=!isEmptyVariable(dropdownItem.likelihoodId)?dropdownItem.likelihoodId:""
    
                let selectedFunctionObjArr = [];
                if(isEmptyVariable(dropdownItem.processList)){
                    let splitArr = dropdownItem.functionList.split("|~|");
                    if(!isEmptyArray(splitArr)){
                        splitArr.map((item)=>{
                            if(!isEmptyVariable(item.split(":-:")[1])){
                                selectedFunctionObjArr.push({
                                    functionId:item.split(":-:")[1]
                                });
                            }
                        })
                    }
                }

                let selectedVAIds = [];
                if(!isEmptyVariable(dropdownItem.valueAdditionList)){
                    let splitArr = dropdownItem.valueAdditionList.split("|~|");
                    if(!isEmptyArray(splitArr)){
                        splitArr.map((item)=>{
                            selectedVAIds.push(parseInt(item.split(":-:")[2]));
                        })
                    }
                }

                let planDate =!isEmptyVariable(dropdownItem.planDate)?moment(dropdownItem.planDate).format("YYYY-MM-DD"):"";
                let startDate = !isEmptyVariable(dropdownItem.startDate)?moment(dropdownItem.startDate).format("YYYY-MM-DD"):"";
                let endDate = !isEmptyVariable(dropdownItem.endDate)?moment(dropdownItem.endDate).format("YYYY-MM-DD"):"";
                let reportDate = !isEmptyVariable(dropdownItem.reportDate)?moment(dropdownItem.reportDate).format("YYYY-MM-DD"):"";
                let periodFromDate = !isEmptyVariable(dropdownItem.periodFromDate)? moment(dropdownItem.periodFromDate).format("YYYY-MM-DD"):"";
                let periodToDate =!isEmptyVariable(dropdownItem.periodToDate)? moment(dropdownItem.periodToDate).format("YYYY-MM-DD"):"";

                if(assignmentTypeFiltered.length === 1){
                    const selectedAuditType = assignmentTypeFiltered[0].auditType?JSON.parse(assignmentTypeFiltered[0].auditType.replace(/'/g, '"')).map(auditType => ({ auditType })):[];
                    this.setState({
                        auditTypesFiltered:selectedAuditType
                    })
                }else{
                    const assignmentTypeFilter = assignmentTypeFiltered.filter(item => item.name === dropdownItem.assignmentTypeName);
                    const selectedAuditType = assignmentTypeFilter[0].auditType?JSON.parse(assignmentTypeFilter[0].auditType.replace(/'/g, '"')).map(auditType => ({ auditType })):[];

                    this.setState({
                        auditTypesFiltered:selectedAuditType
                    })
                }
                let isLikelihood = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDLIKELIHOOD) && e.settingColumnEnabled === "N" && 
                    e.departmentId === dropdownItem.departmentId && e.assignmentTypeId === dropdownItem.assignmentTypeId);

                let isRisk = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDRISK) && e.settingColumnEnabled === "N" && 
                    e.departmentId === dropdownItem.departmentId && e.assignmentTypeId === dropdownItem.assignmentTypeId);

                let isSampleChecked = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DOCLIST) && e.settingColumnEnabled === "Y" && 
                    e.departmentId === dropdownItem.departmentId && e.assignmentTypeId === dropdownItem.assignmentTypeId);

                // Filter the risks based on the selected department and assignment type
                let risks = this.props.risks.filter(risk => risk.departmentId == dropdownItem.departmentId &&
                    risk.assignmentTypeId == dropdownItem.assignmentTypeId) || [];

                // Filter the likelihoods based on the selected department and assignment type
                let likelihoods = this.props.likelihoods.filter(item => item.departmentId == dropdownItem.departmentId &&
                    item.assignmentTypeId == dropdownItem.assignmentTypeId) || [];

                let selectedObservationTempObj = isEmptyVariable(dropdownItem.observationTemplateId) ? [] : {};
                selectedObservationTempObj['templateName']=isEmptyVariable(dropdownItem.observationTemplateName)?observationTemplateDefaultPlaceholder:dropdownItem.observationTemplateName
                selectedObservationTempObj['templateId']=isEmptyVariable(dropdownItem.observationTemplateId)?"":dropdownItem.observationTemplateId

                this.setState({
                    isUnplannedNewAssignment:isUnplannedAssignment,
                    selectedDepartmentId:dropdownItem.departmentId,
                    planDate:planDate,
                    selectedCompanyId:dropdownItem.companyId,
                    selectedCompanyPlaceholder:dropdownItem.companyName,
                    selectedPlannedAssignment:dropdownItem.companyName,
                    companyUnits:newCompanyUnits,
                    selectedUnitObj:selectedUnitObj,
                    projects:projects,
                    employees:employees,
                    selectedProjectObj:selectedProjectObj,
                    selectedEmployeeObj:selectedEmployeeObj,
                    isUnitsDropdownEnabled:true,
    
                    assignmentTypeFiltered:assignmentTypeFiltered,
                    selectedAssignmentTypeId:dropdownItem.assignmentTypeId,
                    selectedAssignmentTypePlaceholder:dropdownItem.assignmentTypeName,
                    selectedAuditType:dropdownItem.auditType,
                    assignmentTypeFlag:false,
                    selectAssignmentEntityFlag:true,
                    observationTemplatesFiltered:observationTemplatesFiltered,
                    selectedObservationTemplateId:isEmptyVariable(dropdownItem.observationTemplateId)?"":dropdownItem.observationTemplateId,
                    selectedObservationTemplatePlaceholder:isEmptyVariable(dropdownItem.observationTemplateName)?observationTemplateDefaultPlaceholder:dropdownItem.observationTemplateName,
                    selectedObservationTempObj:selectedObservationTempObj,
                    valueAdditionflagObs:flagO,

                    execTaskTemplatesFiltered:execTaskTemplatesFiltered,
                    selectedExecTaskTemplateId:dropdownItem.executionTemplateId,
                    selectedExecTaskTemplatePlaceholder:dropdownItem.executionTemplateName,
                    valueAdditionflagExec:flagE,
    
                    selectedFunctionObjArr:selectedFunctionObjArr,
                    selectedProcessObjArr:selectedProcessObjArr,
                    assignmentArea:isEmptyVariable(dropdownItem.assignmentArea)?dropdownItem.plannedAssignmentArea:dropdownItem.assignmentArea,
                    selectedId:dropdownItem.assignmentId,

                    startDate:startDate,
                    endDate:endDate,
                    reportDate:reportDate,
                    referenceNo:dropdownItem.referenceNo,

                    selectedRiskPlaceholder:isEmptyVariable(dropdownItem.riskName)?defaultRiskPlaceholder:dropdownItem.riskName,
                    selectedRiskId:dropdownItem.riskId,
                    isRiskEdit:isEmptyVariable(dropdownItem.riskId),

                    selectedVAIds:selectedVAIds,

                    periodFromDate:periodFromDate,
                    periodToDate:periodToDate,

                    selectedAssignmentGroups:selectedAssignmentGroups,

                    unplannedReasonPlaceholder:unplannedReason,
                    unplannedRemarks:unplannedRemarks,
                    selectedPlannedAssignmentId:dropdownItem.assignmentId,
                    selectedPlannedDropdownItem:dropdownItem,


                    submitClickedAtleastOnce:false,
                    formErrors:{},
                    showLoader:false,
                    departmentSetting: [],
                    selectedLikelihood:isEmptyVariable(dropdownItem.likelihoodName)?defaultLikelihoodPlaceholder:dropdownItem.likelihoodName,
                    selectedLikelihoodId: dropdownItem.likelihoodId,
                    isLikelihoodEdit:isEmptyVariable(dropdownItem.likelihoodId),
                    isLikelihood:isLikelihood,
                    isRisk:isRisk,
                    selectedRiskObj:selectedRiskObj,
                    selectedLikelihoodObj:selectedLikelihoodObj,
                    assignedTaskCount:dropdownItem.assignedTaskCount,
                    isSampleChecked:isSampleChecked,
                    risks:risks,
                    likelihoods:likelihoods
                },() => {
                    // this.annualDropdownClick(dropdownItem)
                });
            }else{
                let companyName=companyDefaultPlaceholder;
                let companyId="";
                let companyUnits = [];
                let projects = [];

                if(this.props.departmentArr.length > 1){
                    selectedDepartmentId="";
                    selectedDepartmentName=departmentDropdownDefaultValue;
                }
                // For engagement type Self- add companyId & name
                if( this.props.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF ){
                    companyName=this.props.company.companyName;
                    companyId=this.props.company.companyId;
                    companyUnits = this.props.units.filter(unit => unit.companyId === this.props.company?.companyId);
                    projects = this.props.projects.filter(item => item.companyId === this.props.company?.companyId);
                }

                let assignmentTypeFiltered = [];
                if(!isEmptyVariable(selectedDepartmentId)){
                    assignmentTypeFiltered = this.props.assignmentType.filter(at => at.departmentId === selectedDepartmentId);
                }

                let departmentSetting = [];
                const departmentIds = !isEmptyArray(this.props.departments) && this.props.departments.map(item => item.departmentId);
                const filteredSettings = !isEmptyArray(this.props.allSettings) && !isEmptyArray(departmentIds) && 
                    this.props.allSettings.filter(item => departmentIds.includes(item.departmentId));
                departmentSetting = !isEmptyArray(filteredSettings) && 
                filteredSettings.filter(item => item.settingColumn.includes(Constants.DIRECT_SCHEDULED) && item.settingColumnEnabled === "N");

                let hidePlannedAssignment = this.state.hidePlannedAssignment;
                hidePlannedAssignment = !isEmptyArray(this.props.allSettings) && this.props.allSettings.some(e => 
                selectedDepartmentId == e.departmentId && e.settingColumn.includes(Constants.DIRECT_SCHEDULED) && e.settingColumnEnabled === "Y");
        
                let newCompanyUnits =[]
                Object.values(companyUnits).map((item)=>{
                    let  tempItem = item
                    tempItem["unitNameAndCity"] = item.unitName+", "+item.city
                    newCompanyUnits.push(tempItem)
                });

                // If there is only one assignment type filtered, update the state with the selected assignment type details
                if(assignmentTypeFiltered.length === 1){
                    let execTaskTemplatesFiltered = this.props.execTaskTemplates.filter(at => at.assignmentTypeId === assignmentTypeFiltered[0].assignmentTypeId);
                    if(execTaskTemplatesFiltered.length === 1){
                        let flag = execTaskTemplatesFiltered[0]?.fixedTemplateFields?.includes('"valueAddition":"Y"');
                        let observationTemplatesFiltered = this.props.observationTemplates.filter(observationItem => observationItem.rootExecuteTemplateId == execTaskTemplatesFiltered[0].rootTemplateId);

                        this.setState({
                            selectedExecTaskTemplateId:execTaskTemplatesFiltered[0].templateId,
                            selectedExecTaskTemplatePlaceholder:execTaskTemplatesFiltered[0].templateName,
                            observationTemplatesFiltered:observationTemplatesFiltered,
                            valueAdditionflagObs:flag,
                        })

                        if(observationTemplatesFiltered.length === 1){
                            this.setState({
                                selectedObservationTempObj:observationTemplatesFiltered[0],
                                selectedObservationTemplatePlaceholder:observationTemplatesFiltered[0].templateName,
                                selectedObservationTemplateId:observationTemplatesFiltered[0].templateId,
                            })
                        }
                    }
                    let selectedAuditType = assignmentTypeFiltered[0].auditType?JSON.parse(assignmentTypeFiltered[0].auditType.replace(/'/g, '"')).map(auditType => ({ auditType })):[];
                    if(selectedAuditType.length === 1){
                        this.setState({
                            selectedAuditType:selectedAuditType[0].auditType,
                            selectAssignmentEntityFlag:true
                        })
                    }else{
                        this.setState({
                            selectedAuditType:auditTypeDefaultPlaceholder,
                            selectAssignmentEntityFlag:false
                        })
                    }
                    let isLikelihood = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDLIKELIHOOD) && e.settingColumnEnabled === "N" &&
                        e.departmentId === assignmentTypeFiltered[0].departmentId && e.assignmentTypeId === assignmentTypeFiltered[0].assignmentTypeId);

                    let isRisk = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDRISK) && e.settingColumnEnabled === "N" &&
                        e.departmentId === assignmentTypeFiltered[0].departmentId && e.assignmentTypeId === assignmentTypeFiltered[0].assignmentTypeId);

                    let isSampleChecked = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DOCLIST) && e.settingColumnEnabled === "Y" && 
                        e.departmentId === assignmentTypeFiltered[0].departmentId && e.assignmentTypeId === assignmentTypeFiltered[0].assignmentTypeId);

                    // Filter the risks based on the selected department and assignment type
                    let risks = this.props.risks.filter(risk => risk.departmentId == assignmentTypeFiltered[0].departmentId &&
                        risk.assignmentTypeId == assignmentTypeFiltered[0].assignmentTypeId) || [];

                     // Filter the risks based on the selected department and assignment type
                    let likelihoods = this.props.likelihoods.filter(risk => risk.departmentId == assignmentTypeFiltered[0].departmentId &&
                        risk.assignmentTypeId == assignmentTypeFiltered[0].assignmentTypeId) || [];

                    this.setState({
                        selectedAssignmentTypePlaceholder:assignmentTypeFiltered[0].name,
                        selectedAssignmentTypeId:assignmentTypeFiltered[0].assignmentTypeId,
                        execTaskTemplatesFiltered:execTaskTemplatesFiltered,
                        selectedPlannedDropdownItem:assignmentTypeFiltered[0],
                        // selectedExecTaskTemplateId:execTaskTemplatesFiltered[0].templateId,
                        // selectedExecTaskTemplatePlaceholder:execTaskTemplatesFiltered[0].templateName,
                        // valueAdditionflagObs:flag,
                        auditTypesFiltered:selectedAuditType,
                        isLikelihood:isLikelihood,
                        isRisk:isRisk,
                        isSampleChecked:isSampleChecked,
                        risks:risks,
                        likelihoods:likelihoods
                    })
                }else{
                    // If there are no assignment types filtered, reset the state to default values.
                    this.setState({
                        selectedAssignmentTypePlaceholder:assignmentTypeDefaultPlaceholder,
                        selectedAssignmentTypeId:"",
                        execTaskTemplatesFiltered:[],
                        selectedPlannedDropdownItem:{},
                        selectedExecTaskTemplateId:"",
                        selectedExecTaskTemplatePlaceholder:execTaskTemplateDefaultPlaceholder,
                        observationTemplatesFiltered:[],
                        selectedObservationTemplateId:"",
                        selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                        selectedObservationTempObj:[],
                        auditTypesFiltered:[],
                        selectedAuditType:auditTypeDefaultPlaceholder,
                        isLikelihood:false,
                        isRisk:false,
                        isSampleChecked:false,
                        risks:[],
                        likelihoods:[]
                    })
                }

                // let selectedAuditType = "";
                // if(this.props.auditTypes.length === 1){
                //     selectedAuditType = this.props.auditTypes[0].auditType
                // }else{
                //     selectedAuditType = auditTypeDefaultPlaceholder;
                // }
                let selectedAssignmentGroups = {
                    groupSet1:[],
                    groupSet2:[],
                    groupSet3:[],
                }
                this.setState({
                    selectedDepartmentId:selectedDepartmentId,
                    selectedDepartmentName:selectedDepartmentName,
                    
                    isUnplannedNewAssignment:false,
                    planDate:"",
                    selectedCompanyId:companyId,
                    selectedCompanyPlaceholder:companyName,
                    
                    companyUnits:newCompanyUnits,
                    projects:projects,
                    employees:[],
                    selectedUnitObj:[],
                    selectedProjectObj:[],
                    selectedEmployeeObj:[],
                    selectedUnitPlaceholder:unitDefaultPlaceholder,
                    selectedProjectPlaceholder:projectDefaultPlaceholder,
                    selectedEmployeePlaceholder:employeeDefaultPlaceholder,
                    isUnitsDropdownEnabled:this.props.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF ? hidePlannedAssignment : false,
                    
                    assignmentTypeFiltered:assignmentTypeFiltered,

                    // observationTemplatesFiltered:observationTemplatesFiltered,
                    // selectedObservationTemplateId:"",
                    // selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                    // selectedObservationTempObj:[],
                    assignmentArea:"",
                    selectedFunctionObjArr:[],
                    selectedProcessObjArr:[],

                    selectedPlannedAssignment:plannedAssignmentDefaultPlaceholder,
                    datalist:[],
                    disablePlannedAssignment:this.props.departmentArr.length > 1?true:false,

                    startDate:"",
                    endDate:"",
                    reportDate:"",
                    referenceNo:"",

                    selectedValuePlaceholder:defaultVAPlaceholder,
                    selectedVAIds:[],

                    periodFromDate:"",
                    periodToDate:"",
                    unplannedReasonPlaceholder:unplannedReasonDefaultPlaceholder,
                    unplannedRemarks:"",

                    tagsSelectedDD1:[],
                    tagsSelectedDD2:[],
                    tagsSelectedDD3:[],
                    selectedAssignmentGroups:selectedAssignmentGroups,
                    submitClickedAtleastOnce:false,
                    formErrors:{},
                    showLoader:false,
                    hidePlannedAssignment:hidePlannedAssignment,
                    departmentSetting:departmentSetting,
                    // selectAssignmentEntityFlag:true,
                    assignmentTypeFlag:!hidePlannedAssignment
                },()=>{
                    if(!hidePlannedAssignment && hasFeatureAccess(Constants.FEATURE_PLANNING)){
                        this.getPlannedAssignmentList();
                    }
                })
            }
        }
        if (!prevProps.showCreateDialog && this.props.showCreateDialog) {
            // Store initial values for dirty check
            this.setState({
                initialFormValues: {
                    selectedPlannedAssignment:this.state.selectedPlannedAssignment,
                    isUnplannedNewAssignment:this.state.isUnplannedNewAssignment,
                    selectedDepartmentName: this.state.selectedDepartmentName,
                    selectedAssignmentTypePlaceholder:this.state.selectedAssignmentTypePlaceholder,
                    // selectedAuditType:this.state.selectedAuditType,
                    // selectedCompanyPlaceholder: this.state.selectedCompanyPlaceholder,
                    selectedUnitObj:this.state.selectedUnitObj,
                    // selectedProjectObj:this.state.selectedProjectObj,
                    // selectedEmployeeObj:this.state.selectedEmployeeObj,
                    referenceNo:this.state.referenceNo,
                    // assignmentArea: this.state.assignmentArea,
                    // startDate: this.state.startDate,
                    // endDate: this.state.endDate,
                    // reportDate:this.state.reportDate,
                    // periodFromDate:this.state.periodFromDate,
                    // periodToDate:this.state.periodToDate,
                    selectedExecTaskTemplatePlaceholder:this.state.selectedExecTaskTemplatePlaceholder,
                    selectedObservationTemplatePlaceholder:this.state.selectedObservationTemplatePlaceholder,
                    selectedRiskPlaceholder:this.state.selectedRiskPlaceholder,
                    selectedLikelihood:this.state.selectedLikelihood,
                    selectedValuePlaceholder:this.state.selectedValuePlaceholder,
                    unplannedReasonPlaceholder:this.state.unplannedReasonPlaceholder,
                    unplannedRemarks:this.state.unplannedRemarks
                },
                isFormDirty: false,
            });
        }
    }

    handleCreateDialogClose = (reload) => {
        this.setState({
            companyUnits:[],
            selectedVAIds:[],
            selectedCompanyObj:[],
            selectedPlannedAssignmentId:""
        },()=>{
            this.props.handleCreateDialogClose(reload);
        })
        
    }

    deptDropdownClick = (item) => {
       
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['department'] = "";
            FormErrorsTemp['functionList'] = "";
            FormErrorsTemp['processList'] = "";
        }
        // Filter the assignment types based on the selected department
        let filteredAT = this.props.assignmentType.filter(at => at.departmentId === item.departmentId);
        
        
        // Check if the planned assignment should be hidden based on the department settings
        let hidePlannedAssignment = this.state.hidePlannedAssignment;
        hidePlannedAssignment = !isEmptyArray(this.props.allSettings) && this.props.allSettings.some(e => 
            item.departmentId == e.departmentId && e.settingColumn.includes(Constants.DIRECT_SCHEDULED) && e.settingColumnEnabled === "Y");
        
            // If the selected department has changed, reset the state and fetch the planned assignment list
            if(this.state.selectedDepartmentId != item.departmentId){
                this.state.selectedCompanyObj={}
                
                // If only one assignment type is found, update the state with the assignment type details
                if(filteredAT.length === 1){
                    let execTaskTemplatesFiltered = this.props.execTaskTemplates.filter(at => at.assignmentTypeId === filteredAT[0].assignmentTypeId);
                    if(execTaskTemplatesFiltered.length === 1){
                        let flag = execTaskTemplatesFiltered[0]?.fixedTemplateFields?.includes('"valueAddition":"Y"');
                        
                        // Filter the observation templates based on the execTaskTemplatesFiltered
                        let observationTemplatesFiltered = this.props.observationTemplates.filter(observationItem => observationItem.rootExecuteTemplateId == execTaskTemplatesFiltered[0].rootTemplateId)

                        this.setState({
                            execTaskTemplatesFiltered:execTaskTemplatesFiltered,
                            selectedExecTaskTemplateId:execTaskTemplatesFiltered[0].templateId,
                            selectedExecTaskTemplatePlaceholder:execTaskTemplatesFiltered[0].templateName,
                            observationTemplatesFiltered:observationTemplatesFiltered,
                            valueAdditionflagObs:flag,
                        })

                        if(observationTemplatesFiltered.length === 1){
                            this.setState({
                                selectedObservationTemplateId:observationTemplatesFiltered[0].templateId,
                                selectedObservationTemplatePlaceholder:observationTemplatesFiltered[0].templateName,
                                selectedObservationTempObj:observationTemplatesFiltered[0]
                            })
                        }else{
                            this.setState({
                                selectedObservationTemplateId:"",
                                selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                                selectedObservationTempObj:[]
                            })
                        }
                    }else{
                        this.setState({
                            selectedExecTaskTemplateId:"",
                            selectedExecTaskTemplatePlaceholder:execTaskTemplateDefaultPlaceholder,
                            selectedObservationTemplateId:"",
                            selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                            selectedObservationTempObj:[],
                            observationTemplatesFiltered:[]
                        })
                    }

                let isLikelihood = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDLIKELIHOOD) && e.settingColumnEnabled === "N" &&
                    e.departmentId === item.departmentId && e.assignmentTypeId === filteredAT[0].assignmentTypeId);

                let isRisk = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDRISK) && e.settingColumnEnabled === "N" &&
                    e.departmentId === item.departmentId && e.assignmentTypeId === filteredAT[0].assignmentTypeId);

                let isSampleChecked = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DOCLIST) && e.settingColumnEnabled === "Y" && 
                    e.departmentId === item.departmentId && e.assignmentTypeId === filteredAT[0].assignmentTypeId);
                
                // Filter the risks based on the selected department and assignment type
                let risks = this.props.risks.filter(risk => risk.departmentId == item.departmentId &&
                    risk.assignmentTypeId == filteredAT[0].assignmentTypeId) || [];
                // if(risks.length === 1){
                //     this.setState({
                //         selectedRiskPlaceholder:risks[0].name,
                //         selectedRiskId:risks[0].riskId,
                //         selectedRiskObj:risks[0]
                //     })
                // }

                // Filter the likelihoods based on the selected department and assignment type
                let likelihoods = this.props.likelihoods.filter(likelihood => likelihood.departmentId == item.departmentId &&
                    likelihood.assignmentTypeId == filteredAT[0].assignmentTypeId) || [];
                // if(likelihoods.length === 1){
                //     this.setState({
                //         selectedLikelihood:likelihoods[0].name,
                //         selectedLikelihoodId:likelihoods[0].riskId,
                //         selectedLikelihoodObj:likelihoods[0]
                //     })
                // }
                
                this.setState({
                    selectedAssignmentTypePlaceholder:filteredAT[0].name,
                    selectedAssignmentTypeId:filteredAT[0].assignmentTypeId,
                    selectedPlannedDropdownItem:filteredAT[0],
                    isLikelihood:isLikelihood,
                    isRisk:isRisk,
                    isSampleChecked:isSampleChecked,
                    risks:risks,
                    likelihoods:likelihoods
                })
            }else{
                // If no assignment types are found, reset the selected assignment type placeholder
                this.setState({
                    selectedAssignmentTypePlaceholder:assignmentTypeDefaultPlaceholder,
                    risks:[],
                    likelihoods:[]
                })
            }

            // Reset the state for planned assignment, units, and functions
            this.setState({
                disablePlannedAssignment:false,
                hidePlannedAssignment:hidePlannedAssignment,
                isUnplannedNewAssignment:false,
                isUnitsDropdownEnabled:false,
                isUnitsDropdownEnabled:hidePlannedAssignment,
                selectedPlannedAssignment:plannedAssignmentDefaultPlaceholder,
                selectedPlannedAssignmentId:"",
                assignmentArea:"",
                selectedFunctionObjArr:[],
                selectedUnitPlaceholder:unitDefaultPlaceholder,
                selectedUnitObj:[],
                companyUnits:[],
            })
        }
        this.setState({
            selectedDepartmentName:item.name,
            selectedDepartmentId:item.departmentId,
            formErrors:FormErrorsTemp,
            assignmentTypeFiltered:filteredAT,
            assignmentTypeFlag:!hidePlannedAssignment,
        },()=>{
             this.checkDirty()
            if(hasFeatureAccess(Constants.FEATURE_PLANNING)){
                this.getPlannedAssignmentList();
            }
        })
    }

    riskDropdownClick = (item) => {
        this.setState({
            selectedRiskPlaceholder:item?item.name:defaultRiskPlaceholder,
            selectedRiskId:item?item.riskId:"",
            selectedRiskObj:item
        },this.checkDirty)
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            if(name === "referenceNo"){
                FormErrorsTemp['referenceNo'] = isEmptyVariable(value)?"Please enter reference no":"";
            }else if(name === "unplannedRemarks"){
            }
        }

        this.setState({
            [name]:value,
            formErrors:FormErrorsTemp
        }, this.checkDirty)
    }

    unplannedDropdownClick = (item) => {
        let FormErrorsTemp  = this.state.formErrors;

        FormErrorsTemp["unplanned"] = "";
        this.setState({
            unplannedReasonPlaceholder:item.reason,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    }

    annualDropdownClick = (dropdownItem) => {
        let companyUnits = [];
        companyUnits = this.props.units.filter(unit => unit.companyId === dropdownItem.companyId);
        let newCompanyUnits = []
        if(dropdownItem.auditType === selectedAssignmentEntityProject){
            newCompanyUnits = [{
                unitNameAndCity:"All",
                unitId:""
            }]
        }
        Object.values(companyUnits).map((item)=>{
            let  tempItem = item
            tempItem["unitNameAndCity"] = item.unitName+", "+item.city
            newCompanyUnits.push(tempItem)
        })
        let assignmentTypeFiltered = this.props.assignmentType.filter(at => at.departmentId === dropdownItem.departmentId);
       
        this.state.selectedCompanyObj=dropdownItem

        let selectedUnitObj = [];
        if(dropdownItem.auditType === selectedAssignmentEntityProject){
            let projectUnitId = dropdownItem.projectUnitId?JSON.parse(dropdownItem.projectUnitId):[];
            projectUnitId.map(item => {
                newCompanyUnits.map((unit)=>{
                    if(unit.unitId==parseInt(item))
                    {
                        selectedUnitObj.push(unit)
                    }
                })
            })
            
            if(selectedUnitObj.length === companyUnits.length){
                selectedUnitObj = [{
                    unitNameAndCity:"All",
                    unitId:""
                }];
            }
        }else if(dropdownItem.auditType === selectedAssignmentEntityEmployee){
            let employeeUnitId = dropdownItem.employeeUnitId?JSON.parse(dropdownItem.employeeUnitId):[];
            employeeUnitId.map(item => {
                newCompanyUnits.map((unit)=>{
                    if(unit.unitId==parseInt(item)){
                        selectedUnitObj.push(unit)
                    }
                })
            })
        }else{
            if(!isEmptyVariable(dropdownItem.unitList)){
                let splitArr = dropdownItem.unitList.split(",");
                if(!isEmptyArray(splitArr)){
                    splitArr.map((item)=>{
                        newCompanyUnits.map((unit)=>{
                            if(unit.unitId==parseInt(item.split(":-:")[1]))
                            {
                                selectedUnitObj.push(unit)
                            }
                        })

                    })
                }
            }
        }

        let selectedProcessObjArr = [];
        if(!isEmptyVariable(dropdownItem.processList)){
            let splitArr = dropdownItem.processList.split("|~|");
            if(!isEmptyArray(splitArr)){
                splitArr.forEach((item)=>{
                    if(!isEmptyVariable(item.split(":-:")[1])){
                        selectedProcessObjArr.push({
                            processId:item.split(":-:")[1]
                        });
                    }
                })
            }
        }

        let selectedFunctionObjArr = [];
        if(!isEmptyVariable(dropdownItem.functionList)){
            let splitArr = dropdownItem.functionList.split("|~|");
            if(!isEmptyArray(splitArr)){
                splitArr.forEach((item)=>{
                    if(!isEmptyVariable(item.split(":-:")[1])){
                        selectedFunctionObjArr.push({
                            functionId:item.split(":-:")[1]
                        });
                    }
                })
            }
        }

        let projects = this.props.projects.filter(item => item.companyId === dropdownItem.companyId);
        let selectedProjectObj = [];
        if(!isEmptyVariable(dropdownItem.projectList)){
            projects.map((project)=>{
                if(project.projectId==parseInt(dropdownItem.projectList.split(":-:")[2]))
                {
                    selectedProjectObj.push(project)
                }
            })
        }

        let employees = this.props.employees.filter(item => {
            return JSON.parse(item.unit).some(unit => 
                unit == dropdownItem.employeeUnitId.replace(/[\[\]]/g, "")
            );
        });

        let newEmployees = []
        Object.values(employees).map((item)=>{
            let tempItem = item
            tempItem["empAndDesignation"] = item.salutation+" "+item.firstName+" "+item.lastName+" ("+item.designation+")"
            newEmployees.push(item)
        })

        let selectedEmployeeObj = [];
        let splitArr = dropdownItem.employeeList.split(";;");
        if(!isEmptyArray(splitArr)){
            splitArr.map(item => {
                newEmployees.map(emp => {
                    if(emp.employeeId == parseInt(item.split(":-:")[1])){
                        selectedEmployeeObj.push(emp)
                    }
                })
            })
        }

        let startDate = moment(dropdownItem.planDate).format("YYYY-MM-DD");
        let execTaskTemplatesFiltered = this.props.execTaskTemplates.filter(at => at.assignmentTypeId === dropdownItem.plannedAssignmentTypeId);
        // If only one template is found, update the state with the template details
        if(execTaskTemplatesFiltered.length === 1){
            let observationTemplatesFiltered = this.props.observationTemplates.filter(observationItem => observationItem.rootExecuteTemplateId == execTaskTemplatesFiltered[0].rootTemplateId)

            this.setState({
                selectedExecTaskTemplateId:execTaskTemplatesFiltered[0].templateId,
                selectedExecTaskTemplatePlaceholder:execTaskTemplatesFiltered[0].templateName,
                observationTemplatesFiltered:observationTemplatesFiltered,
            })
            if(observationTemplatesFiltered.length === 1){
                this.setState({
                    selectedObservationTemplateId:observationTemplatesFiltered[0].templateId,
                    selectedObservationTemplatePlaceholder:observationTemplatesFiltered[0].templateName,
                    selectedObservationTempObj:observationTemplatesFiltered[0]
                })
            }else{
                this.setState({
                    selectedObservationTemplateId:"",
                    selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                    selectedObservationTempObj:[]
                })
            }
        }
        if(assignmentTypeFiltered.length === 1){
            const selectedAuditType = assignmentTypeFiltered[0].auditType?JSON.parse(assignmentTypeFiltered[0].auditType.replace(/'/g, '"')).map(auditType => ({ auditType })):[];
            this.setState({
                auditTypesFiltered:selectedAuditType,
                selectAssignmentEntityFlag:true
            })
        }else{
            const assignmentTypeFilter = assignmentTypeFiltered.filter(item => item.name === dropdownItem.assignmentTypeName);
            const selectedAuditType = assignmentTypeFilter[0].auditType?JSON.parse(assignmentTypeFilter[0].auditType.replace(/'/g, '"')).map(auditType => ({ auditType })):[];

            this.setState({
                auditTypesFiltered:selectedAuditType,
            })
        }
        let isLikelihood = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDLIKELIHOOD) && e.settingColumnEnabled === "N" &&
            e.departmentId === dropdownItem.departmentId && e.assignmentTypeId === dropdownItem.plannedAssignmentTypeId);

        let isRisk = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDRISK) && e.settingColumnEnabled === "N" &&
            e.departmentId === dropdownItem.departmentId && e.assignmentTypeId === dropdownItem.plannedAssignmentTypeId);

        let isSampleChecked = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DOCLIST) && e.settingColumnEnabled === "Y" &&
            e.departmentId === dropdownItem.departmentId && e.assignmentTypeId === dropdownItem.plannedAssignmentTypeId);

        // Filter the risks based on the selected department and assignment type
        let risks = this.props.risks.filter(risk => risk.departmentId == dropdownItem.departmentId && 
            risk.assignmentTypeId == dropdownItem.plannedAssignmentTypeId) || [];
        
        // Filter the likelihoods based on the selected department and assignment type
        let likelihoods = this.props.likelihoods.filter(item => item.departmentId == dropdownItem.departmentId &&
            item.assignmentTypeId == dropdownItem.plannedAssignmentTypeId) || [];

        this.setState({
            selectedScheduleAssignment:false,
            selectedPlannedAssignment:dropdownItem.companyName,
            selectedPlannedAssignmentId:dropdownItem.assignmentId,
            startDate:startDate,
            selectedCompanyId:dropdownItem.companyId,
            selectedCompanyPlaceholder:dropdownItem.companyName,
            isUnitsDropdownEnabled:true,
            selectedUnitObj:selectedUnitObj,
            companyUnits:newCompanyUnits,
            selectedUnitPlaceholder:unitDefaultPlaceholder,
            assignmentTypeFiltered:assignmentTypeFiltered,
            selectedAssignmentTypeId:dropdownItem.plannedAssignmentTypeId,
            selectedAssignmentTypePlaceholder:dropdownItem.assignmentTypeName,
            execTaskTemplatesFiltered:execTaskTemplatesFiltered,
            selectedFunctionObjArr:selectedFunctionObjArr,
            selectedProcessObjArr:selectedProcessObjArr,
            assignmentArea:dropdownItem.plannedAssignmentArea,
            formErrors:{},
            selectedPlannedDropdownItem:dropdownItem,
            selectedAuditType:dropdownItem.auditType,
            selectAssignmentEntityFlag:true,
            assignmentTypeFlag:true,
            isLikelihood:isLikelihood,
            isRisk:isRisk,
            isSampleChecked:isSampleChecked,
            projects:projects,
            employees:employees,
            selectedProjectObj:selectedProjectObj,
            selectedEmployeeObj:selectedEmployeeObj,
            risks:risks,
            likelihoods:likelihoods
        },this.checkDirty)

    }

    onDateChange = (date, dateString) => {
		let planDate = "";
		if (!isEmptyVariable(date)) {
			planDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['planDate'] = "";
		this.setState({
            planDate:planDate,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    };

    onStartDateChange = (date, dateString) => {
		let startDate = "";
		if (!isEmptyVariable(date)) {
			startDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['startDate'] = "";

        // Clear end date if start date is later than the current end date
        let endDate = this.state.endDate;
        if (endDate && moment(startDate).isAfter(moment(endDate))) {
            endDate = "";
            FormErrorsTemp['endDate'] = "";
        }

        // Clear report date if start date is later than the current report date
        let reportDate = this.state.reportDate;
        if (reportDate && moment(startDate).isAfter(moment(reportDate))) {
            reportDate = "";
            FormErrorsTemp['reportDate'] = "";
        }

        // Clear Assignment Review Period From Date if start date is later than the current sample period from date
        let periodFromDate = this.state.periodFromDate;
        if (periodFromDate && moment(startDate).isAfter(moment(periodFromDate))) {
            periodFromDate = "";
            FormErrorsTemp['periodFromDate'] = "";
        }

		this.setState({
            startDate:startDate,
            endDate:endDate,
            periodFromDate:periodFromDate,
            reportDate:reportDate,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    };

    onEndDateChange = (date, dateString) => {
		let endDate = "";
		if (!isEmptyVariable(date)) {
			endDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['endDate'] = "";

        // Clear end date if start date is later than the current end date
        let reportDate = this.state.reportDate;
        if (reportDate && moment(endDate).isAfter(moment(reportDate))) {
            reportDate = "";
            FormErrorsTemp['reportDate'] = "";
        }

         let periodToDate = this.state.periodToDate;
        if(periodToDate && moment(endDate).isAfter(moment(periodToDate))) {
            periodToDate = "";
            FormErrorsTemp['periodToDate'] = "";
        }

		this.setState({
            endDate:endDate,
            reportDate:reportDate,
            periodToDate:periodToDate,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    };

    onReportDateChange = (date, dateString) => {
		let reportDate = "";
		if (!isEmptyVariable(date)) {
			reportDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['reportDate'] = "";
		this.setState({
            reportDate:reportDate,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    };

    onPeriodFromDateChange = (date, dateString) => {
		let periodFromDate = "";
		if (!isEmptyVariable(date)) {
			periodFromDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['periodFromDate'] = "";

        // Clear Sample period to date if sample period from date is later than the current start date
        let periodToDate = this.state.periodToDate;
        if (periodToDate && moment(periodFromDate).isAfter(moment(periodToDate))) {
            periodToDate = "";
            FormErrorsTemp['periodToDate'] = "";
        }

		this.setState({
            periodFromDate:periodFromDate,
            periodToDate:periodToDate,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    };

    onPeriodToDateChange = (date, dateString) => {
		let periodToDate = "";
		if (!isEmptyVariable(date)) {
			periodToDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['periodToDate'] = "";
		this.setState({
            periodToDate:periodToDate,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    };
       
    disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    disabledStartDate = (current) => {
        const { endDate } = this.state;
        return endDate && current > moment(endDate, "YYYY-MM-DD");
    };

    disabledEndDate = (current) => {
        const { startDate } = this.state;
        return startDate && current < moment(startDate, "YYYY-MM-DD");
    };

    disabledReportDate = (current) => {
        const { endDate } = this.state;
        return endDate && current < moment(endDate, "YYYY-MM-DD");
    };

    // Add this function in your class:
    disabledSamplePeriodFromDate = (current) => {
        const { startDate } = this.state;
        let maxDate = startDate ? moment(startDate, "YYYY-MM-DD") : null;
        // Disable if after startDate
        if (maxDate && current.isAfter(maxDate, 'day')) {
            return true;
        }
        return false;
    };

    disabledSamplePeriodToDate = (current) => {
        const { endDate, periodFromDate } = this.state;
        let minDate = periodFromDate ? moment(periodFromDate, "YYYY-MM-DD") : null;
        let maxDate = endDate ? moment(endDate, "YYYY-MM-DD") : null;

        // Disable if before periodFromDate or after endDate
        if (minDate && current.isBefore(minDate, 'day')) {
            return true;
        }
        if (maxDate && current.isAfter(maxDate, 'day')) {
            return true;
        }
        return false;
        // return periodFromDate && current < moment(periodFromDate, "YYYY-MM-DD") 
    };

    //Functions
    handleSelectFunctionDialogClose = () => {
        this.setState({
            showSelectFunctionDialog:false,
        })
    }

    handleSelectFunctionDialogSaveClose = (selectedFunctionObjArr) => {
        let FormErrorsTemp  = this.state.formErrors;
        FormErrorsTemp['functionList'] = "";
        this.setState({
            showSelectFunctionDialog:false,
            selectedFunctionObjArr:selectedFunctionObjArr,
            formErrors:FormErrorsTemp,
        },this.checkDirty)
    }

    handleSelectFunctionDialogShow = () => {
        let formErr = this.state.formErrors;
        if(isEmptyVariable(this.state.selectedDepartmentId) && !this.props.isEdit){
            formErr["functionList"] = "Please select the department before function selection"
            this.setState({
                formErrors:formErr
            })
        }else{
            this.setState({
                showSelectFunctionDialog:true,
            })
        }
    }

    //Process
    handleSelectProcessDialogClose = () => {
        this.setState({
            showSelectProcessDialog:false,
        })
    }

    handleSelectProcessDialogSaveClose = (selectedProcessObjArr) => {
        let FormErrorsTemp  = this.state.formErrors;
        FormErrorsTemp['processList'] = "";
        this.setState({
            showSelectProcessDialog:false,
            formErrors:FormErrorsTemp,
            selectedProcessObjArr:selectedProcessObjArr
        },this.checkDirty)
    }

    handleSelectProcessDialogShow = () => {
        if(this.props.assignmentStartedFlag === false){
            let formErr = this.state.formErrors;
            if(isEmptyVariable(this.state.selectedDepartmentId) && !this.state.isEdit){
                formErr["processList"] = "Please select the department before process selection"
                this.setState({
                    formErrors:formErr
                })
            }else{
                this.setState({
                    showSelectProcessDialog:true,
                })
            }
        }
        
    }

    companyDropdownClick = (item) => {
        if (!item) {
            this.setState({
                selectedCompanyPlaceholder: companyDefaultPlaceholder
            })
            return;
        }
        this.setState({
            showLoader:true,
        })
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['company'] = "";
        }

        let companyUnits = this.props.units.filter(unit => unit.companyId === item?.companyId);
        let projects = [];
        let newCompanyUnits =[]
        if(this.state.selectedAuditType === selectedAssignmentEntityProject){
            newCompanyUnits = [{
                unitNameAndCity:"All",
                unitId:""
            }]
            projects = this.props.projects.filter(projectItem => projectItem.companyId === item?.companyId);
            if(isEmptyArray(projects)){
                this.setState({
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:"No project available for selection. Create project for the selected client."
                })
            }
        }
        Object.values(companyUnits).map((item)=>{
            let tempItem = item
            tempItem["unitNameAndCity"] = item.unitName+", "+item.city
            newCompanyUnits.push(item)
        })

        this.setState({
            selectedCompanyPlaceholder:this.props.company?.companyType!== Constants.USER_ENGAGEMENT_TYPE_SELF?item?.companyName??"":item?.unitNameCityList??"",
            selectedCompanyId:item?.companyId ?? "",
            formErrors:FormErrorsTemp,

            //reset units when company is changed
            isUnitsDropdownEnabled:true,
            selectedUnitObj:[],
            selectedProjectObj:[],
            selectedEmployeeObj:[],
            selectedUnitPlaceholder:unitDefaultPlaceholder,
            selectedProjectPlaceholder:projectDefaultPlaceholder,
            selectedEmployeePlaceholder:employeeDefaultPlaceholder,
            companyUnits:newCompanyUnits,
            projects:projects,
            employees:[],
            showLoader:false,
        },this.checkDirty)
    }

    addSelectionVA = (args) => {
        let FormErrorsTemp  = this.state.formErrors;
        FormErrorsTemp.selectedVA = "";

        if(!isEmptyVariable(args.itemData.valueAdditionId))
        {
            this.state.selectedVAIds.push(args.itemData.valueAdditionId)
        }

        this.setState({
            selectedVAIds:this.state.selectedVAIds,
            formErrors:FormErrorsTemp
        },this.checkDirty)

    }

    removeSelectionVA = (args) => {
        if(!isEmptyVariable(args.itemData.valueAdditionId)){
            let idx = this.state.selectedVAIds.indexOf(args.itemData.valueAdditionId);
            if(idx !== -1){
                this.state.selectedVAIds.splice(idx,1);
            }
        }
        this.setState({
            selectedVAIds:this.state.selectedVAIds
        },this.checkDirty)
    }

    assignmentTypeDropdownClick = (item) => {
        if(this.state.selectedAssignmentTypeId != item.assignmentTypeId){
            let FormErrorsTemp  = this.state.formErrors;

            if(this.state.submitClickedAtleastOnce){
                FormErrorsTemp['assignmentType'] = "";
            }

            // Filter the execution task templates based on the selected assignment type
            let execTaskTemplatesFiltered = this.props.execTaskTemplates.filter(at => at.assignmentTypeId === item.assignmentTypeId);

            // If only one template is found, update the state with the template details
            if(execTaskTemplatesFiltered.length === 1){
                let flag = execTaskTemplatesFiltered[0]?.fixedTemplateFields?.includes('"valueAddition":"Y"');
                let observationTemplatesFiltered = this.props.observationTemplates.filter(observationItem => observationItem.rootExecuteTemplateId == execTaskTemplatesFiltered[0].rootTemplateId)

                this.setState({
                    selectedExecTaskTemplateId:execTaskTemplatesFiltered[0].templateId,
                    selectedExecTaskTemplatePlaceholder:execTaskTemplatesFiltered[0].templateName,
                    observationTemplatesFiltered:observationTemplatesFiltered,
                    valueAdditionflagObs:flag,
                })
                if(observationTemplatesFiltered.length === 1){
                    this.setState({
                        selectedObservationTemplateId:observationTemplatesFiltered[0].templateId,
                        selectedObservationTemplatePlaceholder:observationTemplatesFiltered[0].templateName,
                        selectedObservationTempObj:observationTemplatesFiltered[0]
                    })
                }else{
                    this.setState({
                        selectedObservationTemplateId:"",
                        selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                        selectedObservationTempObj:[]
                    })
                }
            }else{
                // If no templates are found, reset the selected template ID and placeholder
                this.setState({
                    selectedExecTaskTemplateId:"",
                    selectedExecTaskTemplatePlaceholder:execTaskTemplateDefaultPlaceholder,
                    selectedObservationTemplateId:"",
                    selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                    selectedObservationTempObj:[],
                    observationTemplatesFiltered:[]
                })
            }
            const selectedAuditType = item.auditType?JSON.parse(item.auditType?.replace(/'/g, '"')).map(auditType => ({ auditType })):[];
            if(selectedAuditType.length === 1){
                let FormErrorsTemp = this.state.formErrors;
                FormErrorsTemp['selectedAuditType'] = "";
                this.setState({
                    selectedAuditType:selectedAuditType[0].auditType,
                    auditTypesFiltered:selectedAuditType,
                    selectAssignmentEntityFlag:true,
                    formErrors:FormErrorsTemp
                })
            }else{
                this.setState({
                    selectedAuditType:auditTypeDefaultPlaceholder,
                    auditTypesFiltered:selectedAuditType,
                    selectAssignmentEntityFlag:false
                })
            }
            let isLikelihood = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDLIKELIHOOD) && e.settingColumnEnabled === "N" &&
                e.departmentId === item.departmentId && e.assignmentTypeId === item.assignmentTypeId);

            let isRisk = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDRISK) && e.settingColumnEnabled === "N" &&
                e.departmentId === item.departmentId && e.assignmentTypeId === item.assignmentTypeId);
            
            let isSampleChecked = this.props.allSettings.some(e => e.settingColumn.includes(Constants.DOCLIST) && e.settingColumnEnabled === "Y" &&
                e.departmentId === item.departmentId && e.assignmentTypeId === item.assignmentTypeId);

            // Filter the risks based on the selected department and assignment type
            let risks = this.props.risks.filter(risk => risk.departmentId == item.departmentId && 
                risk.assignmentTypeId == item.assignmentTypeId) || [];
            // if(risks.length === 1){
            //     this.setState({
            //         selectedRiskPlaceholder:risks[0].name,
            //         selectedRiskId:risks[0].riskId,
            //         selectedRiskObj:risks[0]
            //     })
            // }

            // Filter the likelihoods based on the selected department and assignment type
            let likelihoods = this.props.likelihoods.filter(likelihood => likelihood.departmentId == item.departmentId &&
                likelihood.assignmentTypeId == item.assignmentTypeId) || [];
            // if(likelihoods.length === 1){
            //     this.setState({
            //         selectedLikelihood:likelihoods[0].name,
            //         selectedLikelihoodId:likelihoods[0].riskId,
            //         selectedLikelihoodObj:likelihoods[0]
            //     })
            // }

            if(!this.props.isEdit){
                if(this.props.company?.companyType !== Constants.USER_ENGAGEMENT_TYPE_SELF){
                    this.setState({
                        selectedCompanyPlaceholder:companyDefaultPlaceholder,
                    })
                }
                this.setState({
                    selectedCompanyObj:[]
                })
            }
            this.setState({
                selectedAssignmentTypePlaceholder:item.name,
                selectedAssignmentTypeId:item.assignmentTypeId,
                formErrors:FormErrorsTemp,
                execTaskTemplatesFiltered:execTaskTemplatesFiltered,
                selectedPlannedDropdownItem:item,
                isLikelihood:isLikelihood,
                selectedUnitObj:[],
                selectedProjectObj:[],
                isUnitsDropdownEnabled:this.props.company?.companyType == Constants.USER_ENGAGEMENT_TYPE_SELF ? true : false,
                selectedUnitPlaceholder:unitDefaultPlaceholder,
                selectedProjectPlaceholder:projectDefaultPlaceholder,
                selectedEmployeePlaceholder:employeeDefaultPlaceholder,
                isRisk:isRisk,
                isSampleChecked:isSampleChecked,
                risks:risks,
                likelihoods:likelihoods
            },this.checkDirty)
        }
    }

    auditTypeDropdownClick = (item) => {
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['selectedAuditType'] = "";
        }
        this.setState({
            selectedAuditType:item.auditType,
            selectedEmployeeObj:[],
            selectedProjectObj:[],
            formErrors:FormErrorsTemp,
            selectedCompanyObj:[],
            selectedUnitObj:[],
            isUnitsDropdownEnabled:this.props.company?.companyType!== Constants.USER_ENGAGEMENT_TYPE_SELF?
            (this.props.isEdit?true:false):true
        },this.checkDirty)
    }

    observationTemplateDropdownClick = (item) => {
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['observationTemplate'] = "";
        }

        let flag = item?.fixedTemplateFields?.includes('"valueAddition":"Y"');

        this.setState({
            selectedObservationTempObj:item,
            selectedObservationTemplatePlaceholder:item?item.templateName:observationTemplateDefaultPlaceholder,
            selectedObservationTemplateId:item?item.templateId:"",
            valueAdditionflagExec:flag,
            formErrors:FormErrorsTemp,
        },this.checkDirty)
    }

    execTaskTemplateDropdownClick = (item) => {
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['execTaskTemplate'] = "";
        }
        let flag = item?.fixedTemplateFields?.includes('"valueAddition":"Y"');
        let observationTemplatesFiltered = this.props.observationTemplates.filter(observationItem => observationItem.rootExecuteTemplateId == item.rootTemplateId)
        if(observationTemplatesFiltered.length === 1){
            this.setState({
                selectedObservationTempObj:observationTemplatesFiltered[0],
                selectedObservationTemplatePlaceholder:observationTemplatesFiltered[0].templateName,
                selectedObservationTemplateId:observationTemplatesFiltered[0].templateId,
            })
        }else{
            this.setState({
                selectedObservationTempObj:[],
                selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                selectedObservationTemplateId:"",
            })
        }
        this.setState({
            selectedExecTaskTemplatePlaceholder:item.templateName,
            selectedExecTaskTemplateId:item.templateId,
            observationTemplatesFiltered:observationTemplatesFiltered,
            valueAdditionflagObs:flag,
            formErrors:FormErrorsTemp,
        },this.checkDirty)
    }

    handleSelection = (e) => {
        // e.stopPropagation();
        let type = e.target.name;

        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['assignmentArea'] = "";
        }

        this.setState({
            assignmentArea:type,
            formErrors:FormErrorsTemp
        },this.checkDirty);
    }

    handleTagChange1 = (newValueArr, actionMeta) => {
		this.setState({
            selectedAssignmentGroups: {...this.state.selectedAssignmentGroups, groupSet1:newValueArr},
        },this.checkDirty);
	};

    handleTagChange2 = (newValueArr, actionMeta) => {
		this.setState({
            selectedAssignmentGroups: {...this.state.selectedAssignmentGroups, groupSet2:newValueArr},
        },this.checkDirty);
	};

    handleTagChange3 = (newValueArr, actionMeta) => {
		this.setState({
            selectedAssignmentGroups: {...this.state.selectedAssignmentGroups, groupSet3:newValueArr},
        },this.checkDirty);
	};

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    handleSelectionIsNew = (e) => {
        let isChecked = e.target.checked;
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp.checkListType = "";
       
        
        // For engagement type Self- show/clear companyUnits dropdown
        let isUnitsDropdownEnabled = this.state.isUnitsDropdownEnabled;
        let companyUnits = this.state.companyUnits;
        // let selectedUnitObj = this.state.selectedUnitObj;
        // let selectedUnitPlaceholder = this.state.selectedUnitPlaceholder;
   
        if(this.props.company?.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF){
            companyUnits = this.props.units.filter(unit => unit.companyId === this.props.company?.companyId);
            isUnitsDropdownEnabled= isChecked;
        }else{
            isUnitsDropdownEnabled = false
        }
        if(!isChecked){
            isUnitsDropdownEnabled = false
            this.setState({
                isLikelihood:false,
                isRisk:false,
                // isSampleChecked:false
            })
            // selectedUnitPlaceholder=unitDefaultPlaceholder
            // selectedUnitObj=[];
        }

        let newCompanyUnits =[]
        Object.values(companyUnits).map((item)=>{
            let  tempItem = item
            tempItem["unitNameAndCity"] = item.unitName+", "+item.city
            newCompanyUnits.push(tempItem)
        })

        this.state.selectedCompanyObj=[]
        
        this.setState({
            isUnplannedNewAssignment:isChecked,
            isUnitsDropdownEnabled:false,
            formErrors:FormErrorsTemp,
            companyUnits:newCompanyUnits,
            selectedUnitPlaceholder:unitDefaultPlaceholder,
            selectedUnitObj:[],
            selectedPlannedAssignment:plannedAssignmentDefaultPlaceholder,
            selectedExecTaskTemplateId:"",
            selectedExecTaskTemplatePlaceholder:execTaskTemplateDefaultPlaceholder,
            execTaskTemplatesFiltered:[],
            selectedObservationTemplateId:"",
            selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
            selectedObservationTempObj:[],
            observationTemplatesFiltered:[],
            // selectedUnitIds:[],
            assignmentArea:"",
            selectedPlannedAssignmentId:"",
            selectedFunctionObjArr:[],
            selectAssignmentEntityFlag:true,
            assignmentTypeFlag:!isChecked,
            selectedAuditType:auditTypeDefaultPlaceholder,
            selectedAssignmentTypePlaceholder:assignmentTypeDefaultPlaceholder,
            selectedAssignmentTypeId:"",
            auditTypesFiltered:[],
            // if planned Assignment selected after want to clear Client field value while click on Create Unplanned Assignment
            selectedCompanyObj:[], 
            selectedCompanyPlaceholder:companyDefaultPlaceholder
        },this.checkDirty)
    }

    handleCreateMaster = () => {
        this.setState({
            submitClickedAtleastOnce:true,
            showLoader:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(!this.props.isEdit){
            if(isEmptyVariable(this.state.selectedDepartmentName) 
            || this.state.selectedDepartmentName === departmentDropdownDefaultValue){
                isError = true;
                FormErrorsTemp['department'] = "Please select the Department";
            }
        }



        // if(isEmptyVariable(this.state.planDate)){
        //     isError=true;
        //     FormErrorsTemp['planDate'] = "Please select the plan date";
        // }
        if(!this.state.hidePlannedAssignment && (isEmptyVariable(this.state.selectedPlannedAssignment) 
        || this.state.selectedPlannedAssignment===plannedAssignmentDefaultPlaceholder) && !this.state.isUnplannedNewAssignment)
        {
            isError = true;
            FormErrorsTemp['assignment'] = "Please select an already planned assignment";
        }

        if(this.props.company?.companyType!== Constants.USER_ENGAGEMENT_TYPE_SELF && 
        (isEmptyVariable(this.state.selectedCompanyPlaceholder) 
        || this.state.selectedCompanyPlaceholder === companyDefaultPlaceholder)){
            isError = true;
            FormErrorsTemp['company'] = "Please select Company";
        }

        if(isEmptyVariable(this.state.selectedAssignmentTypePlaceholder) 
        || this.state.selectedAssignmentTypePlaceholder === assignmentTypeDefaultPlaceholder){
            isError = true;
            FormErrorsTemp['assignmentType'] = "Please select Assignment Type";
        }
        if(isEmptyVariable(this.state.selectedAuditType)
        || this.state.selectedAuditType === auditTypeDefaultPlaceholder){
            isError = true;
            FormErrorsTemp['selectedAuditType'] = "Please select Audit Type";
        }
        // if(isEmptyVariable(this.state.selectedObservationTemplatePlaceholder) 
        // || this.state.selectedObservationTemplatePlaceholder === observationTemplateDefaultPlaceholder){
        //     isError = true;
        //     FormErrorsTemp['observationTemplate'] = "Please select observation template";
        // }

        if(isEmptyVariable(this.state.selectedExecTaskTemplatePlaceholder) 
        || this.state.selectedExecTaskTemplatePlaceholder === execTaskTemplateDefaultPlaceholder){
            isError = true;
            FormErrorsTemp['execTaskTemplate'] = "Please select Execution Template";
        }

        if(this.state.selectedAuditType !== selectedAssignmentEntityProject && isEmptyArray(this.state.selectedUnitObj)){
            isError = true;
            FormErrorsTemp['selectedUnit'] = "Please select Units";
        }

        if(isEmptyArray(this.state.selectedProjectObj) &&
        this.state.selectedAuditType === selectedAssignmentEntityProject){
            isError = true;
            FormErrorsTemp['selectedProject'] = "Please select Project";
        }

        if(isEmptyArray(this.state.selectedEmployeeObj) && 
        this.state.selectedAuditType === selectedAssignmentEntityEmployee){
            isError = true;
            FormErrorsTemp['selectedEmployees'] = "Please select Employees";
        }

        if(isEmptyVariable(this.state.assignmentArea)){
            isError = true;
            FormErrorsTemp['assignmentArea'] = "Please select Scope";
        }

        if(this.state.assignmentArea==="process" &&
        isEmptyArray(this.state.selectedProcessObjArr)){
            isError = true;
            FormErrorsTemp['processList'] = "Please select Process";
        }

        if(this.state.assignmentArea==="function" &&
        isEmptyArray(this.state.selectedFunctionObjArr)){
            isError = true;
            FormErrorsTemp['functionList'] = "Please select Function";
        }

        //additional fields
        if(isEmptyVariable(this.state.startDate)){
            isError=true;
            FormErrorsTemp['startDate'] = "Please select the Start Date";
        }

        if(isEmptyVariable(this.state.endDate)){
            isError=true;
            FormErrorsTemp['endDate'] = "Please select the End Date";
        }

        var tempStartDate = new Date(this.state.startDate); //Year, Month, Date    
           var tempEndDate = new Date(this.state.endDate);


        if(!isEmptyVariable(this.state.startDate) &&
        !isEmptyVariable(this.state.endDate) &&
        (tempEndDate < tempStartDate)){    
        // !moment(this.state.endDate).isAfter(this.state.startDate)){
            isError=true;
            FormErrorsTemp['endDate'] = "End Date must be greater than Start Date";
        }

        // if(isEmptyVariable(this.state.reportDate)){
        //     isError=true;
        //     FormErrorsTemp['reportDate'] = "Please select the report date";
        // }

        // if(isEmptyVariable(this.state.referenceNo)){
        //     isError=true;
        //     FormErrorsTemp['referenceNo'] = "Please enter reference no";
        // }

        // if(isEmptyVariable(this.state.periodFromDate)){
        //     isError=true;
        //     FormErrorsTemp['periodFromDate'] = "Please select the period from";
        // }

        // if(isEmptyVariable(this.state.periodToDate)){
        //     isError=true;
        //     FormErrorsTemp['periodToDate'] = "Please select the period to";
        // }

        // if(!isEmptyVariable(this.state.periodFromDate) &&
        // !isEmptyVariable(this.state.periodToDate) &&
        // !moment(this.state.periodToDate).isAfter(this.state.periodFromDate)){
        //     isError=true;
        //     FormErrorsTemp['periodToDate'] = "End date must be greater than start date";
        // }

        // if(!isEmptyVariable(this.state.periodToDate) &&
        // !isEmptyVariable(this.state.endDate) &&
        // moment(this.state.periodToDate).isAfter(this.state.endDate)){
        //     isError=true;
        //     FormErrorsTemp['periodToDate'] = "Sample period to date should not be greater than end date";
        // }
        
        if(!isEmptyVariable(this.state.reportDate) &&
        !isEmptyVariable(this.state.endDate) &&
        moment(this.state.endDate).isAfter(this.state.reportDate)){
            isError=true;
            FormErrorsTemp['reportDate'] = "Report Date should not be less than End Date";
        }

        // if(isEmptyVariable(this.state.selectedRiskPlaceholder) ||
        // this.state.selectedRiskPlaceholder===defaultRiskPlaceholder){
        //     isError=true;
        //     FormErrorsTemp['risk'] = "Please select the risk";
        // }

        if((this.state.valueAdditionflagObs || this.state.valueAdditionflagExec) &&
            isEmptyArray(this.state.selectedVAIds)){
            isError=true;
            FormErrorsTemp['selectedVA'] = "Please select the Value Addition";
        }


        if(this.state.isUnplannedNewAssignment){
            if(isEmptyVariable(this.state.unplannedReasonPlaceholder) ||
            this.state.unplannedReasonPlaceholder === unplannedReasonDefaultPlaceholder){
                isError=true;
                FormErrorsTemp['unplanned'] = "Please select Reason";
            }
        }

        let selectedUnitIds = [];
        let unit = this.state.companyUnits;
        Object.values(this.state.selectedUnitObj).map((item)=>{
            if(item.unitNameAndCity === "All"){
                selectedUnitIds = unit.map(item => item.unitId);
                selectedUnitIds.shift();
            }else{
                selectedUnitIds.push(item.unitId)
            }
        })

        let selectedProjectIds = [];
        Object.values(this.state.selectedProjectObj).map((item)=>{
            selectedProjectIds.push(item.projectId)
        })

        let selectedEmployeeIds = [];
        Object.values(this.state.selectedEmployeeObj).map((item)=>{
            selectedEmployeeIds.push(item.employeeId)
        })

        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

        }else{
            let url = "";
            let postParams = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                projectIds:JSON.stringify(selectedProjectIds),
                employeeIds:JSON.stringify(selectedEmployeeIds),
                assignmentTypeId:this.state.selectedAssignmentTypeId,
                auditType:this.state.selectedAuditType,
                observationTemplateId:this.state.selectedObservationTemplateId,
                executionTemplateId:this.state.selectedExecTaskTemplateId,
                assignmentArea:this.state.assignmentArea,
                referenceNo:this.state.referenceNo,
                startDate:this.state.startDate,
                endDate:this.state.endDate,
                reportDate:this.state.reportDate,
                reportFormat:'Word',
                periodFromDate:this.state.periodFromDate,
                periodToDate:this.state.periodToDate,
                riskId:this.state.selectedRiskId,
                valueAdditions:JSON.stringify(this.state.selectedVAIds),
                likelihoodId:this.state.selectedLikelihoodId,
            }
            if(this.state.selectedAuditType === selectedAssignmentEntityProject){
                postParams.projectUnits = JSON.stringify(selectedUnitIds);
            }else if(this.state.selectedAuditType === selectedAssignmentEntityEmployee){
                postParams.employeeUnits = JSON.stringify(selectedUnitIds);
            }else{
                postParams.units = JSON.stringify(selectedUnitIds);
            }
            if(this.state.assignmentArea === "Process"){
                let processIds = [];

                this.state.selectedProcessObjArr.map(item=>{
                    processIds.push(item.processId.toString())
                })
                postParams.processIds = JSON.stringify(processIds)

            }else if(this.state.assignmentArea === "Function"){
                let functionIds = [];
                this.state.selectedFunctionObjArr.map(item=>{
                    functionIds.push(item.functionId.toString())
                })
                postParams.functionIds = JSON.stringify(functionIds)
            }else if(this.state.assignmentArea === "CheckList"){
                
            }

            if(this.state.selectedAssignmentGroups !== undefined && Object.keys(this.state.selectedAssignmentGroups).length !== 0){
                postParams['selectedAssignmentGroups'] = JSON.stringify(this.state.selectedAssignmentGroups);
            }

            if(this.props.isEdit){
                url = Constants.UpdateScheduledAssignment;
                postParams.assignmentId = this.state.selectedId;

                //if it is unplanned assignment and user is trying to edit it then we will have to pass
                //reason and remark
                if(this.state.isUnplannedNewAssignment){
                    postParams.unplannedReason = this.state.unplannedReasonPlaceholder;
                    postParams.unplannedRemark = this.state.unplannedRemarks;
                }
            }else{
                if(this.state.isUnplannedNewAssignment || this.state.hidePlannedAssignment){
                    url = Constants.ScheduleNewAssignment;
                    postParams.planDate = this.state.planDate;
                    postParams.departmentId = this.state.selectedDepartmentId;
                    postParams.companyId = this.state.selectedCompanyId;
                    postParams.unplannedReason = this.state.unplannedReasonPlaceholder;
                    postParams.unplannedRemark = this.state.unplannedRemarks;
                }else{
                    url = Constants.ScheduleAssignment;
                    postParams.assignmentId = this.state.selectedPlannedAssignmentId;
                }
            }
            // FormErrorsTemp['apiErr'] = "";
            // this.setState({
            //     formErrors:FormErrorsTemp,
            // });

            fetch(url,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postParams)
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        showCreateDialog:false,
                        showLoader:false,
                        isEdit:false,
                        selectedId:"",
                        name:"",
                        shortName:"",
                        description:"",
                    },() => {
                        this.handleCreateDialogClose(true);
                    });
                }else{
                    this.setState({
                        showLoader:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    });
                }
            });
        }
    }

    getPlannedAssignmentList = () => {
        this.setState({
            showLoader:true,
        });

        // let curDate = new Date();
        // let startDate = curDate.getFullYear()+"-"+(curDate.getMonth()+1)+"-1";
        // let endDate = "2050-12-31";

        let postParam = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            resultsize:500,
            status:"Reviewed",
            // startDate:startDate,
            // endDate:endDate,
            departmentId:this.state.selectedDepartmentId
        }

        fetch(Constants.GetPlannedAssignments,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams(postParam)
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    datalist:data.data.result,
                });
            }else{
                this.setState({
                    datalist:[],
                    showLoader:false,
                });
            }
            
        });
    }

    // Akshay's Code Start Here 
    selectedScheduleAssignment = ()=>{

        this.setState({
            selectedScheduleAssignment:true
        },this.checkDirty)
        

    }

    selectedScheduleAssignmentClose=()=>{
        this.setState({
            selectedScheduleAssignment:false,
        })
    }

    unitDropdownClick = (item) => {
        let unitItem = [];
        let selectedUnitObj=[];
        let FormErrorsTemp = this.state.formErrors;
        if(Array.isArray(item)){
            unitItem = item;
        }else if(item){
            unitItem.push(item);
        }
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['selectedUnit'] = "";
        }
        for(var i =0;i<unitItem.length;i++)
        {
            selectedUnitObj.push(unitItem[i])
        }
        let employees = [];
        if(selectedUnitObj.length > 0){
            employees = this.props.employees.filter(item => {
                const units = JSON.parse(item.unit); // Parse the unit string into an array
                return units.includes(selectedUnitObj[0]?.unitId)
            })
            if(this.state.selectedAuditType === selectedAssignmentEntityEmployee){
                if(isEmptyArray(employees)){
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:"No employee available for selection. Create employee for the selected client."
                    })
                }
            }
        }
        let newEmployees = []
        Object.values(employees).map((item)=>{
            let tempItem = item
            tempItem["empAndDesignation"] = item.salutation+" "+item.firstName+" "+item.lastName+" ("+item.designation+")"
            newEmployees.push(item)
        })
        this.setState({
            selectedUnitObj:selectedUnitObj,
            selectedEmployeeObj:[],
            formErrors:FormErrorsTemp,
            selectedEmployeePlaceholder:employeeDefaultPlaceholder,
            employees:newEmployees,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    }

    projectDropdownClick = (item) => {
        let projectItem = [];
        if(Array.isArray(item)){
            projectItem = item;
        }else{
            projectItem.push(item);
        }
        let selectedProjectObj=[];
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['selectedProject'] = "";
        }
        for(var i =0;i<projectItem.length;i++)
        {
            selectedProjectObj.push(projectItem[i])
        }
        this.setState({
            selectedProjectObj:selectedProjectObj,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    }

    employeeDropdownClick = (item) => {
        let employeeItem = [];
        if(Array.isArray(item)){
            employeeItem = item;
        }else{
            employeeItem.push(item);
        }
        let selectedEmployeeObj=[];
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['selectedEmployees'] = "";
        }
        for(var i =0;i<employeeItem.length;i++)
        {
            selectedEmployeeObj.push(employeeItem[i])
        }
        this.setState({
            selectedEmployeeObj:selectedEmployeeObj,
            formErrors:FormErrorsTemp
        },this.checkDirty)
    }

    showPreviousRefNoDialog = () =>{
        this.setState({
            showPreviousRefDialog:true
        })

    }

    closePreviousAssignDialogBox = () =>{
        this.setState({
            showPreviousRefDialog:false
        })
    }

    likelihoodDropdownClick = (item) => {
        this.setState({
            selectedLikelihood: item?item.name:defaultLikelihoodPlaceholder,
            selectedLikelihoodId: item?item.riskId:"",
            selectedLikelihoodObj:item
        },this.checkDirty)
    }

    showRiskLikelihood = (isScheduled, isOngoing, isActive, selectedId) => {
        const {isEdit } = this.props;
        // Scheduled disable to enable
        const isScheduledActive = isScheduled && isActive;
        // Scheduled enable to disable
        const isScheduledNotActive = isScheduled && !isActive && !isEmptyVariable(selectedId);
        // Ongoing disable to enable
        const isOngoingActive = isOngoing && isActive;
        // Ongoing enable to disable
        const isOngoingNotActive = isOngoing && !isActive && !isEmptyVariable(selectedId);
        
        return ((!isEdit && isActive) || isScheduledActive || isScheduledNotActive || isOngoingActive || isOngoingNotActive);
    }

    // componentDidMount() {
    //     document.addEventListener('keydown', this.handleKeyDown);
    // }

    // componentWillUnmount() {
    //     document.removeEventListener('keydown', this.handleKeyDown);
    // }

    // handleKeyDown = (event) => {
    //     const { showCreateDialog } = this.props;
    //     if (!showCreateDialog) return;

    //     // Only close modal, do NOT save
    //     if (event.key === 'Escape') {
    //         event.preventDefault();
    //         this.handleCreateDialogClose(false, 'keyboard');
    //     }
    //     // Optionally, block Enter/Space from saving
    //     if (event.key === 'Enter' || event.key === ' ') {
    //         event.preventDefault();
    //         this.handleCreateMaster();
    //         // Do nothing, or optionally close modal if you want
    //         // this.handleCreateDialogClose(false, 'keyboard');
    //     }
    //     // if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
    //     //     event.preventDefault(); // Prevent unwanted default actions
    //     //     this.handleCreateDialogClose(false, 'keyboard'); // Close modal
    //     // }
    // }
  
    // Intercept close actions:
    handleCreateDialogClose = (reload, source = 'button') => {
        // if (this.state.isFormDirty && !this.state.showConfirmClose) {
        //     this.setState({ showConfirmClose: true, pendingCloseAction: source });
        //     return;
        // }
        // ...existing close logic...
        this.setState({
            // isFormDirty: false,
            // showConfirmClose: false,
            // pendingCloseAction: null,
        }, () => {
            this.props.handleCreateDialogClose(reload);
        });
    }

    // Confirmation dialog handlers:
    handleConfirmClose = () => {
        this.setState({ showConfirmClose: false, isFormDirty: false }, () => {
            this.handleCreateDialogClose(false);
        });
    }

    handleCancelClose = () => {
        this.setState({ showConfirmClose: false, pendingCloseAction: null });
    };

    // Call this after every field change
    checkDirty = () => {
        const fieldsToCheck = [
            'selectedPlannedAssignment',
            'isUnplannedNewAssignment',
            'selectedDepartmentName',
            'selectedAssignmentTypePlaceholder',
            'selectedUnitObj',
            'referenceNo',
            // 'endDate',
            // 'reportDate',
            // 'periodFromDate',
            // 'periodToDate',
            'selectedExecTaskTemplatePlaceholder',
            'selectedObservationTemplatePlaceholder',
            'selectedRiskPlaceholder',
            'selectedLikelihood',
            'selectedValuePlaceholder',
            'unplannedReasonPlaceholder',
            'unplannedRemarks'
            // ...add more fields as needed
        ];
        const dirty = isFormDirty(this.state.initialFormValues || {}, this.state, fieldsToCheck);
        if (dirty !== this.state.isFormDirty) {
            this.setState({ isFormDirty: dirty });
        }
    }

    // Method to clear selected value for dropdowns
    clearSelectedValue = (type) => {
        switch(type) {
            case 'department':
                this.setState({
                    selectedAssignmentTypePlaceholder:assignmentTypeDefaultPlaceholder,
                    selectedAssignmentTypeId:"",
                    execTaskTemplatesFiltered:[],
                    selectedPlannedDropdownItem:{},
                    selectedExecTaskTemplateId:"",
                    selectedExecTaskTemplatePlaceholder:execTaskTemplateDefaultPlaceholder,
                    selectedObservationTemplateId:"",
                    selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                    selectedObservationTempObj:[],
                    observationTemplatesFiltered:[],
                    valueAdditionflagObs:false,
                    isLikelihood:false,
                    isRisk:false,
                    isSampleChecked:false,
                    risks:[],
                    likelihoods:[]
                })
                break;
            case 'assignmentType':
                this.setState({
                    selectedAssignmentTypePlaceholder: assignmentTypeDefaultPlaceholder,
                    selectedAssignmentTypeId:"",
                    selectedExecTaskTemplateId:"",
                    selectedExecTaskTemplatePlaceholder:execTaskTemplateDefaultPlaceholder,
                    selectedObservationTemplateId:"",
                    selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                    selectedObservationTempObj:[],
                    observationTemplatesFiltered:[],
                    valueAdditionflagObs:false,
                    selectedAuditType:auditTypeDefaultPlaceholder,
                    auditTypesFiltered:[],
                    selectAssignmentEntityFlag:false,
                    selectedCompanyPlaceholder:companyDefaultPlaceholder,
                    selectedCompanyObj:[],
                    execTaskTemplatesFiltered:[],
                    selectedPlannedDropdownItem:{},
                    isLikelihood:false,
                    isUnitsDropdownEnabled:false,
                    isRisk:false,
                    isSampleChecked:false,
                    risks:[],
                    likelihoods:[]
                });
                break;
            case 'assignmentEntity':
                this.setState({
                    selectedAuditType: auditTypeDefaultPlaceholder,
                    isUnitsDropdownEnabled:false
                });
                break;
            case 'executionTemplate':
                this.setState({
                    selectedExecTaskTemplatePlaceholder: execTaskTemplateDefaultPlaceholder,
                    selectedExecTaskTemplateId: '',
                    selectedObservationTemplateId:"",
                    selectedObservationTemplatePlaceholder:observationTemplateDefaultPlaceholder,
                    selectedObservationTempObj:[],
                    observationTemplatesFiltered:[],
                    valueAdditionflagObs:false
                });
                break;
            case 'unplannedReason':
                this.setState({
                    unplannedReasonPlaceholder: unplannedReasonDefaultPlaceholder
                });
                break;
            default:
                break;
        }
    }

    render(){
        let fields = {text:"unitNameAndCity",value:"unitId"}
        let fieldsVA = {text:"name",value:"valueAdditionId"}
        const isScheduled = this.props.isEdit && this.props.selectedItem.assignmentStatus == Constants.ASSIGNMENT_STATUS_SCHEDULED;
        const isOngoing = this.props.isEdit && this.props.selectedItem.assignmentStatus == Constants.ASSIGNMENT_STATUS_ONGOING;

        return(
            <div>
                <Modal className="custom-dialog scheduled-assignment" show={this.props.showCreateDialog} 
                backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <h5>{this.props.isEdit?"Edit Assignment":"Schedule Assignment"}</h5>
                        <button 
                            onClick={this.handleCreateDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div class="modal-body">
                        
                        <div class="addnew-modal-form">
                            {
                                !this.props.isEdit &&
                                !isEmptyArray(this.props.departmentArr) &&
                                this.props.departmentArr.length > 1 &&
                                <div class="addnew-modal-form-group">
                                    <p>Department*</p>
                                    <RegularDropdown 
                                        placeholder={this.state.selectedDepartmentName}
                                        dropdownArr={this.props.departmentArr}
                                        labelParam="name"
                                        onDropDownItemClick={this.deptDropdownClick}
                                        defaultPlaceholderDropDown={departmentDropdownDefaultValue}
                                        clearSelectedValue={()=>this.clearSelectedValue('department')}
                                    />
                                    {
                                        !isEmptyVariable(this.state.formErrors['department']) &&
                                        <span class="cm-error">{this.state.formErrors['department']}</span>
                                    }
                                </div>
                            }

                            {
                                !this.state.hidePlannedAssignment && !this.props.isEdit && 
                                <div className="row custom-row">
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p> Planned Assignment*</p>
                                            {/* Akshay's Code Start Here */}
                                            
                            
                                         <input 
                                            type="text" 
                                            placeholder={this.state.selectedPlannedAssignment} 
                                            // name="referenceNo"
                                            disabled={(this.props.departmentArr.length > 1 && 
                                                this.state.selectedDepartmentName == departmentDropdownDefaultValue) ||
                                                this.state.isUnplannedNewAssignment}
                                            maxlength="0" 
                                            style={{caretColor:"transparent"}}
                                            onClick={this.selectedScheduleAssignment}
                                        />
                                            
                                            {/* <RegularDropdown 
                                                placeholder={this.state.selectedPlannedAssignment}
                                                dropdownArr={this.state.datalist}
                                                labelParam={this.props.company?.companyType!== Constants.USER_ENGAGEMENT_TYPE_SELF?"companyName":"unitNameCityList"}
                                                onDropDownItemClick={this.annualDropdownClick}
                                                disabled = {this.state.disablePlannedAssignment || this.state.isUnplannedNewAssignment}
                                                defaultPlaceholderDropDown={plannedAssignmentDefaultPlaceholder}
                                            /> */}

                                            {
                                                !this.state.isUnplannedNewAssignment  &&
                                                !isEmptyVariable(this.state.formErrors['assignment']) &&
                                                <span class="cm-error">{this.state.formErrors['assignment']}</span>
                                            }
                                            {/* {
                                                !isEmptyVariable(this.state.formErrors['department']) &&
                                                <span class="cm-error">{this.state.formErrors['department']}</span>
                                            } */}
                                        </div>
                                    </div>
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>&nbsp;</p>
                                            <TreeNodeCheckBox
                                            style={{padding:"7px 0px",marginLeft:0}}
                                            themeSettings={this.props.themeSettings}>
                                                <input 
                                                    type="checkbox"
                                                    name="isUnplannedNewAssignment"
                                                    id="isUnplannedNewAssignment"
                                                    disabled={(this.props.departmentArr.length > 1 && 
                                                        this.state.selectedDepartmentName == departmentDropdownDefaultValue)}
                                                    onChange={this.handleSelectionIsNew}
                                                    checked={this.state.isUnplannedNewAssignment}
                                                />
                                                <label for="isUnplannedNewAssignment"
                                                style={{marginLeft:6}}>Create Unplanned Assignment</label>
                                            </TreeNodeCheckBox>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>Assignment Type*</p>
                                        <RegularDropdown 
                                            placeholder={this.state.selectedAssignmentTypePlaceholder}
                                            dropdownArr={this.state.assignmentTypeFiltered}
                                            labelParam="name"
                                            onDropDownItemClick={this.assignmentTypeDropdownClick}
                                            defaultPlaceholderDropDown={assignmentTypeDefaultPlaceholder}
                                            disabled={this.props.assignmentStartedFlag || this.state.assignmentTypeFlag}
                                            clearSelectedValue={()=>this.clearSelectedValue('assignmentType')}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['assignmentType']) &&
                                            <span class="cm-error">{this.state.formErrors['assignmentType']}</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>Assignment Entity*</p>
                                        <RegularDropdown 
                                            placeholder={this.state.selectedAuditType}
                                            dropdownArr={this.state.auditTypesFiltered}
                                            labelParam="auditType"
                                            disabled={this.state.selectAssignmentEntityFlag}
                                            onDropDownItemClick={this.auditTypeDropdownClick}
                                            defaultPlaceholderDropDown={auditTypeDefaultPlaceholder}
                                            clearSelectedValue={()=>this.clearSelectedValue('assignmentEntity')}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['selectedAuditType']) &&
                                            <span class="cm-error">{this.state.formErrors['selectedAuditType']}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row custom-row">
                                {
                                    this.props.company?.companyType!== Constants.USER_ENGAGEMENT_TYPE_SELF &&
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Client*</p>
                                            {/* <RegularDropdown 
                                                placeholder={this.state.selectedCompanyPlaceholder}
                                                dropdownArr={this.props.companies}
                                                labelParam="companyName"
                                                onDropDownItemClick={this.companyDropdownClick}
                                                disabled={!this.state.isUnplannedNewAssignment}
                                                defaultPlaceholderDropDown={companyDefaultPlaceholder}
                                            /> */}

                                            <ReactSelectDropdown
                                                handleReactSelectClose={this.companyDropdownClick}
                                                selectedDDObj= {this.state.selectedCompanyObj}
                                                selectDropdownArr={this.props.companies}
                                                label={"companyName"}
                                                value={"companyId"}
                                                placeholder={this.state.selectedCompanyPlaceholder}
                                                disabled={!this.state.isUnplannedNewAssignment && !this.state.hidePlannedAssignment ||
                                                    this.state.selectedAuditType === auditTypeDefaultPlaceholder}
                                                isClearSelect={true}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['company']) &&
                                                <span class="cm-error">{this.state.formErrors['company']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                                {this.state.selectedAuditType !== auditTypeDefaultPlaceholder &&
                                    this.state.selectedAuditType !== selectedAssignmentEntityUnit &&
                                    <div className="col-md-6 custom-col">
                                        {this.state.selectedAuditType !== auditTypeDefaultPlaceholder &&
                                            this.state.selectedAuditType === selectedAssignmentEntityProject &&
                                            <div className="addnew-modal-form-group">
                                                <p>{this.state.selectedAuditType[0].toUpperCase() + this.state.selectedAuditType.slice(1)}*</p>
                                                <ReactSelectDropdown
                                                    handleReactSelectClose={this.projectDropdownClick}
                                                    selectedDDObj= {this.state.selectedProjectObj}
                                                    selectDropdownArr={this.state.projects}
                                                    label={"projectName"}
                                                    value={"projectId"}
                                                    placeholder={this.state.selectedProjectPlaceholder}
                                                    isClearSelect={true}
                                                />
                                                {
                                                    !isEmptyVariable(this.state.formErrors['selectedProject']) &&
                                                    <span className="cm-error">{this.state.formErrors['selectedProject']}</span>
                                                }
                                            </div>
                                        }
                                        {(this.state.selectedAuditType !== auditTypeDefaultPlaceholder &&
                                            this.state.selectedAuditType === selectedAssignmentEntityEmployee) &&
                                            <div className="addnew-modal-form-group">
                                                <p>Units{this.state.selectedAuditType !== selectedAssignmentEntityProject && "*"}</p> 
                                                <ReactSelectDropdown
                                                    handleReactSelectClose={this.unitDropdownClick}
                                                    selectedDDObj= {this.state.selectedUnitObj}
                                                    selectDropdownArr={this.state.companyUnits}
                                                    label={"unitNameAndCity"}
                                                    value={"unitId"}
                                                    placeholder={this.state.selectedUnitPlaceholder}
                                                    disabled={!this.state.isUnitsDropdownEnabled}
                                                    isClearSelect={true}
                                                    // isMultiselect ={true}
                                                />
                                                {
                                                    !isEmptyVariable(this.state.formErrors['selectedUnit']) &&
                                                    <span className="cm-error">{this.state.formErrors['selectedUnit']}</span>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                {(this.state.selectedAuditType === auditTypeDefaultPlaceholder ||
                                    this.state.selectedAuditType === selectedAssignmentEntityUnit) &&
                                    <div className="col-md-6 custom-col">
                                        <div className="addnew-modal-form-group">
                                            <p>Units{this.state.selectedAuditType !== selectedAssignmentEntityProject && "*"}</p> 
                                            <ReactSelectDropdown
                                                handleReactSelectClose={this.unitDropdownClick}
                                                selectedDDObj= {this.state.selectedUnitObj}
                                                selectDropdownArr={this.state.companyUnits}
                                                label={"unitNameAndCity"}
                                                value={"unitId"}
                                                placeholder={this.state.selectedUnitPlaceholder}
                                                disabled={!this.state.isUnitsDropdownEnabled}
                                                isClearSelect={true}
                                                // isMultiselect ={true}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['selectedUnit']) &&
                                                <span className="cm-error">{this.state.formErrors['selectedUnit']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="row custom-row">
                                {/* <div className="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>Date*</p>
                                        <DatePicker
                                            onChange={this.onDateChange}
                                            format={"DD/MM/YYYY"}
                                            disabledDate={this.disabledDate}
                                            value={!isEmptyVariable(this.state.planDate) ? moment(this.state.planDate) : ""}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['planDate']) &&
                                            <span class="cm-error">{this.state.formErrors['planDate']}</span>
                                        }
                                    </div>
                                </div> */}
                                {this.state.selectedAuditType !== auditTypeDefaultPlaceholder &&
                                    this.state.selectedAuditType === selectedAssignmentEntityEmployee &&
                                    <div className="col-md-6 custom-col">
                                        <div className="addnew-modal-form-group">
                                            <p>{this.state.selectedAuditType[0].toUpperCase() + this.state.selectedAuditType.slice(1)}*</p>
                                            <ReactSelectDropdown
                                                handleReactSelectClose={this.employeeDropdownClick}
                                                selectedDDObj= {this.state.selectedEmployeeObj}
                                                selectDropdownArr={this.state.employees}
                                                label={"empAndDesignation"}
                                                value={"employeeId"}
                                                placeholder={this.state.selectedEmployeePlaceholder}
                                                isMultiselect={true}
                                                isClearSelect={true}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['selectedEmployees']) &&
                                                <span className="cm-error">{this.state.formErrors['selectedEmployees']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                                {(this.state.selectedAuditType !== auditTypeDefaultPlaceholder &&
                                    this.state.selectedAuditType !== selectedAssignmentEntityUnit) &&
                                    this.state.selectedAuditType !== selectedAssignmentEntityEmployee &&
                                    <div className="col-md-6 custom-col">
                                        <div className="addnew-modal-form-group">
                                            <p>Units{this.state.selectedAuditType !== selectedAssignmentEntityProject && "*"}</p> 
                                            <ReactSelectDropdown
                                                handleReactSelectClose={this.unitDropdownClick}
                                                selectedDDObj= {this.state.selectedUnitObj}
                                                selectDropdownArr={this.state.companyUnits}
                                                label={"unitNameAndCity"}
                                                value={"unitId"}
                                                placeholder={this.state.selectedUnitPlaceholder}
                                                disabled={!this.state.isUnitsDropdownEnabled}
                                                isClearSelect={true}
                                                // isMultiselect ={true}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['selectedUnit']) &&
                                                <span className="cm-error">{this.state.formErrors['selectedUnit']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                                <div className="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>Reference No.</p>
                                        <div className='row custom-row'>
                                            <input 
                                                type="text" 
                                                style={{width:"80%",marginLeft:10}}
                                                placeholder="Enter Reference Number" 
                                                name="referenceNo"
                                                onChange ={this.handleChange}
                                                value={this.state.referenceNo}
                                            />
                                            <span className="tool" data-title="Previous Reference No Details">
                                                {!isEmptyArray(this.state.selectedUnitObj) && !isEmptyVariable(this.state.selectedAssignmentTypeId) &&
                                                    <AssigmentDetailsIconLayout themeSettings={this.props.themeSettings} style={{marginLeft:5}}>
                                                        <span className="material-icons" onClick={this.showPreviousRefNoDialog} >info</span>
                                                    </AssigmentDetailsIconLayout>
                                                }
                                            </span>
                                        </div>
                                        {
                                            !isEmptyVariable(this.state.formErrors['referenceNo']) &&
                                            <span className="cm-error">{this.state.formErrors['referenceNo']}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row custom-row">
                                <div class="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>Scope*</p>
                                        <TableRadioButton
                                        style={{marginLeft:0,display:"inline-flex"}}
                                        themeSettings={this.props.themeSettings}>
                                            <input 
                                                type="checkbox"
                                                name={"Process"}
                                                id={"processCb"}
                                                onChange={this.handleSelection}
                                                checked={this.state.assignmentArea==="Process"?true:false}
                                                disabled={this.props.assignmentStartedFlag}
                                            />
                                            <label for={"processCb"} 
                                            style={{marginLeft:0}}>Process</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                        style={{marginLeft:10,display:"inline-flex"}}
                                        themeSettings={this.props.themeSettings}>
                                            <input 
                                                type="checkbox"
                                                name={"Function"}
                                                id={"functionCb"}
                                                onChange={this.handleSelection}
                                                checked={this.state.assignmentArea==="Function"?true:false}
                                                disabled={this.props.assignmentStartedFlag}
                                            />
                                            <label for={"functionCb"} 
                                            style={{marginLeft:0}}>Function</label>
                                        </TableRadioButton>
                                        {/* {hasFeatureAccess(Constants.FEATURE_CHECKLIST) &&
                                            <TableRadioButton
                                            style={{marginLeft:10,display:"inline-flex"}}
                                            themeSettings={this.props.themeSettings}>
                                                <input 
                                                    type="checkbox"
                                                    name={"CheckList"}
                                                    id={"checklistCb"}
                                                    onChange={this.handleSelection}
                                                    checked={this.state.assignmentArea==="CheckList"?true:false}
                                                    disabled={this.props.assignmentStartedFlag}
                                                />
                                                <label for={"checklistCb"} 
                                                style={{marginLeft:0}}>Checklist</label>
                                            </TableRadioButton>
                                        } */}
                                        {
                                            !isEmptyVariable(this.state.formErrors['assignmentArea']) &&
                                            <span className="cm-error">{this.state.formErrors['assignmentArea']}</span>
                                        }
                                    </div>
                                </div>
                                <div class="col-md-6 custom-col">
                                {
                                    this.state.assignmentArea==="Function" &&
                                    <div className="addnew-modal-form-group">
                                        <p>Function</p>
                                        <div className="dummy-dropdown" tabIndex={0} onKeyPress={this.onKeyBtnPress}  
                                        onClick={this.handleSelectFunctionDialogShow}>
                                            <p class="placeholder-text">
                                                {isEmptyArray(this.state.selectedFunctionObjArr)
                                                ?functionDropdownDefaultValue
                                                :this.state.selectedFunctionObjArr.length === 1
                                                ?"1 Function Selected"
                                                :this.state.selectedFunctionObjArr.length+" Functions Selected"}
                                            </p>
                                            <span class="material-icons">keyboard_arrow_right</span>
                                        </div>
                                        {
                                            !isEmptyVariable(this.state.formErrors['functionList']) &&
                                            <span className="cm-error">{this.state.formErrors['functionList']}</span>
                                        }
                                    </div>
                                }   
                                {
                                    this.state.assignmentArea==="Process" &&
                                    <div className="addnew-modal-form-group">
                                        <p>Process</p>
                                        <div className="dummy-dropdown" tabIndex={0} onKeyPress={this.onKeyBtnPress}  
                                        onClick={this.handleSelectProcessDialogShow}>
                                            <p class="placeholder-text">
                                                {isEmptyArray(this.state.selectedProcessObjArr)
                                                ?processDropdownDefaultValue
                                                :this.state.selectedProcessObjArr.length === 1
                                                ?"1 Process Selected"
                                                :this.state.selectedProcessObjArr.length+" Processes Selected"}
                                            </p>
                                            <span class="material-icons">keyboard_arrow_right</span>
                                        </div>
                                        {
                                            !isEmptyVariable(this.state.formErrors['processList']) &&
                                            <span className="cm-error">{this.state.formErrors['processList']}</span>
                                        }
                                    </div>
                                }  
                                </div>
                            </div>
                            
                            <p className="schedule-assignment-heading">Timeline</p>
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>Start*</p>
                                        <DatePicker
                                            onChange={this.onStartDateChange}
                                            format={"DD/MM/YYYY"}
                                            // disabledDate={(current) => current.isBefore(moment().subtract(1,"day"))}
                                            // disabledDate={this.disabledStartDate}
                                            // disabledDate={this.disabledDate}
                                            value={!isEmptyVariable(this.state.startDate) ? moment(this.state.startDate) : ""}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['startDate']) &&
                                            <span class="cm-error">{this.state.formErrors['startDate']}</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>End*</p>
                                        <DatePicker
                                            onChange={this.onEndDateChange}
                                            format={"DD/MM/YYYY"}
                                            disabledDate={this.disabledEndDate}
                                            // disabledDate={this.disabledDate}
                                            value={!isEmptyVariable(this.state.endDate) ? moment(this.state.endDate) : ""}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['endDate']) &&
                                            <span class="cm-error">{this.state.formErrors['endDate']}</span>
                                        }
                                    </div>
                                </div>
                            </div> 
                            
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>Report</p>
                                        <DatePicker
                                            onChange={this.onReportDateChange}
                                            format={"DD/MM/YYYY"}
                                            disabledDate={this.disabledReportDate}
                                            // disabledDate={this.disabledDate}
                                            value={!isEmptyVariable(this.state.reportDate) ? moment(this.state.reportDate) : ""}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['reportDate']) &&
                                            <span class="cm-error">{this.state.formErrors['reportDate']}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            {this.state.isSampleChecked &&
                            <>
                                <p className="schedule-assignment-heading">Assignment Review Period</p>
                                <div className="row custom-row">
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>From</p>
                                            <DatePicker
                                                onChange={this.onPeriodFromDateChange}
                                                format={"DD/MM/YYYY"}
                                                disabledDate={this.disabledSamplePeriodFromDate}
                                                value={!isEmptyVariable(this.state.periodFromDate) ? moment(this.state.periodFromDate) : ""}
                                                />
                                            {
                                                !isEmptyVariable(this.state.formErrors['periodFromDate']) &&
                                                <span class="cm-error">{this.state.formErrors['periodFromDate']}</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>To</p>
                                            <DatePicker
                                                onChange={this.onPeriodToDateChange}
                                                format={"DD/MM/YYYY"}
                                                disabledDate={this.disabledSamplePeriodToDate}
                                                value={!isEmptyVariable(this.state.periodToDate) ? moment(this.state.periodToDate) : ""}
                                                />
                                            {
                                                !isEmptyVariable(this.state.formErrors['periodToDate']) &&
                                                <span class="cm-error">{this.state.formErrors['periodToDate']}</span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            }
                            <p className="schedule-assignment-heading">Other Details</p>
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div class="addnew-modal-form-group">
                                        <p>Execution Template*</p>
                                        <RegularDropdown 
                                            placeholder={this.state.selectedExecTaskTemplatePlaceholder}
                                            dropdownArr={this.state.execTaskTemplatesFiltered}
                                            labelParam="templateName"
                                            onDropDownItemClick={this.execTaskTemplateDropdownClick}
                                            defaultPlaceholderDropDown={execTaskTemplateDefaultPlaceholder}
                                            disabled={this.props.assignmentStartedFlag}
                                            clearSelectedValue={()=>this.clearSelectedValue('executionTemplate')}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['execTaskTemplate']) &&
                                            <span class="cm-error">{this.state.formErrors['execTaskTemplate']}</span>
                                        }
                                    </div>
                                </div>
                                {hasFeatureAccess(Constants.FEATURE_OBSERVATION) &&
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Observation Template</p>
                                            <ReactSelectDropdown
                                                handleReactSelectClose={this.observationTemplateDropdownClick}
                                                selectedDDObj={this.state.selectedObservationTempObj}
                                                selectDropdownArr={this.state.observationTemplatesFiltered}
                                                label={"templateName"}
                                                value={"templateId"}
                                                placeholder={this.state.selectedObservationTemplatePlaceholder}
                                                isClearSelect={true}
                                                disabled={this.props.assignmentStartedFlag?((isEmptyVariable(this.state.selectedObservationTemplatePlaceholder) ||this.state.selectedObservationTemplatePlaceholder==="Select Observation Template")?false:true):false}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['observationTemplate']) &&
                                                <span class="cm-error">{this.state.formErrors['observationTemplate']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                                {this.showRiskLikelihood(isScheduled, isOngoing, this.state.isRisk, this.state.selectedRiskId) &&
                                    hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) &&
                                   <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Risk</p>
                                            <ReactSelectDropdown
                                                handleReactSelectClose={this.riskDropdownClick}
                                                selectedDDObj= {this.state.selectedRiskObj}
                                                selectDropdownArr={this.state.risks}
                                                label={"name"}
                                                value={"riskId"}
                                                placeholder={this.state.selectedRiskPlaceholder}
                                                isClearSelect={isOngoing?false:true}
                                                disabled={isOngoing && !this.state.isRiskEdit}
                                            />
                                            {/* {
                                                !isEmptyVariable(this.state.formErrors['risk']) &&
                                                <span class="cm-error">{this.state.formErrors['risk']}</span>
                                            } */}

                                        </div>
                                    </div>
                                }
                                {this.showRiskLikelihood(isScheduled, isOngoing, this.state.isLikelihood, this.state.selectedLikelihoodId) &&
                                    hasFeatureAccess(Constants.FEATURE_MATRIX_LIKELIHOOD) &&
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Likelihood</p>
                                            <ReactSelectDropdown
                                                handleReactSelectClose={this.likelihoodDropdownClick}
                                                selectedDDObj= {this.state.selectedLikelihoodObj}
                                                selectDropdownArr={this.state.likelihoods}
                                                label={"name"}
                                                value={"riskId"}
                                                placeholder={this.state.selectedLikelihood}
                                                isClearSelect={isOngoing?false:true}
                                                disabled={isOngoing && !this.state.isLikelihoodEdit}
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.valueAdditionflagObs || this.state.valueAdditionflagExec) &&
                                    <div className="col-md-6 custom-col">
                                        <div className="addnew-modal-form-group">
                                            <p>Value Addition</p>
                                            <MultiSelectComponent 
                                                id="vaCheckbox"
                                                dataSource={this.props.valueAdditions}
                                                fields={fieldsVA}
                                                placeholder={this.state.selectedValuePlaceholder} 
                                                mode="CheckBox"
                                                closePopupOnSelect={false}
                                                allowFiltering={false}
                                                select={this.addSelectionVA}
                                                removed={this.removeSelectionVA}
                                                cssClass="clientsChecklist dialogcl"
                                                value={this.state.selectedVAIds}
                                                showDropDownIcon={true}
                                                showClearButton={true}
                                                // enabled={this.props.assignmentStartedFlag?false:true}
                                            >
                                                <Inject services={[CheckBoxSelection]} />
                                            </MultiSelectComponent>
                                            {
                                                !isEmptyVariable(this.state.formErrors['selectedVA']) &&
                                                <span className="cm-error">{this.state.formErrors['selectedVA']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="row custom-row">
                                {   
                                    !isEmptyVariable(this.state.selectedDepartmentId) &&
                                    !isEmptyArray(this.props.allSettings) &&
                                    this.props.allSettings.map(item=>{
                                        if(item.settingColumn.includes("groupSet") 
                                            && item.departmentId == this.state.selectedDepartmentId
                                            && item.settingColumnEnabled === "Y" && !isEmptyVariable(item.settingValue)){
                                            return <div className="col-md-6 custom-col">
                                                <div className="addnew-modal-form-group">
                                                    <p>{item.settingValue}</p>
                                                    <CreatableSelect
                                                        isMulti
                                                        placeholder="Add Groups"
                                                        styles={epicCustomStyles}
                                                        classNamePrefix="dialog-react-select"
                                                        value={this.state.selectedAssignmentGroups?.[item.settingColumn]}
                                                        onChange={
                                                            item.settingColumn === "groupSet1"
                                                            ?
                                                                this.handleTagChange1
                                                            :   
                                                                item.settingColumn === "groupSet2"
                                                                ?
                                                                    this.handleTagChange2
                                                                :
                                                                    this.handleTagChange3
                                                        }
                                                        options={
                                                            this.props.assignmentGroups?.[this.state.selectedDepartmentId]?.[item.settingColumn]
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        }else{
                                            return null;
                                        }
                                    })
                                }
                                
                            </div>
                            
                            {
                                this.state.isUnplannedNewAssignment &&
                                !this.state.isEdit &&
                                <div className="row custom-row">
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Unplanned Reason*</p>
                                            <RegularDropdown 
                                                placeholder={this.state.unplannedReasonPlaceholder}
                                                dropdownArr={this.props.unplannedReason}
                                                labelParam="reason"
                                                onDropDownItemClick={this.unplannedDropdownClick}
                                                defaultPlaceholderDropDown={unplannedReasonDefaultPlaceholder}
                                                clearSelectedValue={()=>this.clearSelectedValue('unplannedReason')}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['unplanned']) &&
                                                <span class="cm-error">{this.state.formErrors['unplanned']}</span>
                                            }
                                        </div>
                                    </div>
                                    <div  className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Unplanned Remarks</p>
                                            <textarea type="text" placeholder="Enter Remarks" spellCheck="true" 
                                            name="unplannedRemarks" value={this.state.unplannedRemarks} onChange={this.handleChange}/>
                                            {
                                                !isEmptyVariable(this.state.formErrors['unplannedRemarks']) &&
                                                <span class="cm-error">{this.state.formErrors['unplannedRemarks']}</span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }

                            {/* {this.state.formErrors['apiErr'] ?
                                <div className="addnew-modal-form-group">
                                    <span class="cm-error">{this.state.formErrors['apiErr']}</span>
                                </div>
                                : null
                            } */}
                        </div>
                        <div class="modal-close-save">
                            <div class="close-save-col">
                                <button onClick={this.handleCreateDialogClose} type="button" class="modal-close">Cancel</button>
                                <DialogSaveButton disabled={this.state.showLoader}
                                themeSettings={this.props.themeSettings} onClick={this.handleCreateMaster} type="button">
                                    {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                                </DialogSaveButton>
                            </div>
                        </div>
                    </div>

                </Modal>
                {/* Akshay's Code Start Here */}
                 <SelectPlannedAssignment 
                  selectedScheduleAssignment={this.state.selectedScheduleAssignment} 
                  datalist= {this.state.datalist}
                  selectedPlannedAssignmentId = {this.state.selectedPlannedAssignmentId} 
                  companyType = {this.props.company?.companyType }
                  onSaveButtonClick={this.annualDropdownClick} 
                  onCancleButtonClick={this.selectedScheduleAssignmentClose}/>

                {/* Akshay's Code End Here */}
                <SelectFunctionDialog
                    showFunctionsDialog={this.state.showSelectFunctionDialog}
                    handleSelectFuncDialogClose={this.handleSelectFunctionDialogClose}
                    handleSelectFunctionDialogSaveClose={this.handleSelectFunctionDialogSaveClose}
                    selectedFunctionObjArr={this.state.selectedFunctionObjArr}
                    departmentId={this.state.selectedDepartmentId}
                    assignedTaskCount={this.state.assignedTaskCount}
                    themeSettings = {this.props.themeSettings}
                    isScheduled={isScheduled}
                />
                <SelectProcessDialog
                    showProcessesDialog={this.state.showSelectProcessDialog}
                    handleSelectProcessDialogClose={this.handleSelectProcessDialogClose}
                    handleSelectProcessDialogSaveClose={this.handleSelectProcessDialogSaveClose}
                    selectedProcessObjArr={this.state.selectedProcessObjArr}
                    departmentId={this.state.selectedDepartmentId}
                    assignedTaskCount={this.state.assignedTaskCount}
                    themeSettings = {this.props.themeSettings}
                    isScheduled={isScheduled}
                />
                 <PreviousRefNoDialog
                    showDialogBox={this.state.showPreviousRefDialog}
                    closeDialogBox={this.closePreviousAssignDialogBox}
                    unitList = {this.state.selectedUnitObj}
                    plannedAssignmentId = {this.state.selectedPlannedAssignmentId}
                    companyId = {this.state.selectedCompanyId}
                    assignmentTypeId ={this.state.selectedAssignmentTypeId} 
                    dropdownItem = {this.state.selectedPlannedDropdownItem}
                    themeSettings={this.props.themeSettings}
                    userDetails ={userDetails}
                />
                <AlertDialog 
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type= {Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                    themeSettings={this.props.themeSettings}
                />
                <AlertDialog
                    showAlertDialog={this.state.showConfirmClose}
                    handleAlertDialogClose={this.handleCancelClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogMessage="You have started filling the data in the form. Do you want to cancel the form?"
                    proceedBtnClick={this.handleConfirmClose}
                    proceedBtnLabel="Yes"
                    cancelBtnLabel="No"
                    themeSettings={this.props.themeSettings}
                />
            </div>
        )
    }
}

export default CreateAnnualPlan;